/**
 * NCS color palette (name + hex) for floorplanner fill selection.
 * Slimmed from boodil-client NcsColorPicker palette — hex-only, no RGB floats.
 */

export type NcsColorOption = {
  name: string;
  hex: string;
};

export const NCS_COLORS: NcsColorOption[] = [
  {
    "name": "NCS S 0300-N",
    "hex": "#F6F5F1"
  },
  {
    "name": "NCS S 0500-N",
    "hex": "#EDECE8"
  },
  {
    "name": "NCS S 1000-N",
    "hex": "#DFDEDC"
  },
  {
    "name": "NCS S 1500-N",
    "hex": "#D1D0CC"
  },
  {
    "name": "NCS S 2000-N",
    "hex": "#C8C8C6"
  },
  {
    "name": "NCS S 2500-N",
    "hex": "#BBBAB8"
  },
  {
    "name": "NCS S 3000-N",
    "hex": "#B0AFAD"
  },
  {
    "name": "NCS S 3500-N",
    "hex": "#A5A4A3"
  },
  {
    "name": "NCS S 4000-N",
    "hex": "#979797"
  },
  {
    "name": "NCS S 4500-N",
    "hex": "#8D8D8D"
  },
  {
    "name": "NCS S 5000-N",
    "hex": "#858585"
  },
  {
    "name": "NCS S 5500-N",
    "hex": "#7C7B79"
  },
  {
    "name": "NCS S 6000-N",
    "hex": "#717171"
  },
  {
    "name": "NCS S 6500-N",
    "hex": "#656565"
  },
  {
    "name": "NCS S 7000-N",
    "hex": "#5C5B59"
  },
  {
    "name": "NCS S 7500-N",
    "hex": "#4F4F4F"
  },
  {
    "name": "NCS S 8000-N",
    "hex": "#403F3E"
  },
  {
    "name": "NCS S 8500-N",
    "hex": "#2E2D2C"
  },
  {
    "name": "NCS S 9000-N",
    "hex": "#18191A"
  },
  {
    "name": "NCS S 0502-Y",
    "hex": "#F1EFE3"
  },
  {
    "name": "NCS S 1002-Y",
    "hex": "#DCDCD2"
  },
  {
    "name": "NCS S 1502-Y",
    "hex": "#D1D0C7"
  },
  {
    "name": "NCS S 2002-Y",
    "hex": "#C5C2B9"
  },
  {
    "name": "NCS S 2502-Y",
    "hex": "#B8B8AE"
  },
  {
    "name": "NCS S 3502-Y",
    "hex": "#A2A29B"
  },
  {
    "name": "NCS S 4502-Y",
    "hex": "#908D84"
  },
  {
    "name": "NCS S 5502-Y",
    "hex": "#7B7872"
  },
  {
    "name": "NCS S 6502-Y",
    "hex": "#67645E"
  },
  {
    "name": "NCS S 7502-Y",
    "hex": "#514F49"
  },
  {
    "name": "NCS S 8502-Y",
    "hex": "#34322C"
  },
  {
    "name": "NCS S 0502-Y50R",
    "hex": "#F1EBE3"
  },
  {
    "name": "NCS S 1002-Y50R",
    "hex": "#E3DDD6"
  },
  {
    "name": "NCS S 1502-Y50R",
    "hex": "#D2CCC6"
  },
  {
    "name": "NCS S 2002-Y50R",
    "hex": "#C7C1BB"
  },
  {
    "name": "NCS S 0502-R",
    "hex": "#EFE8E6"
  },
  {
    "name": "NCS S 1002-R",
    "hex": "#E0DAD9"
  },
  {
    "name": "NCS S 1502-R",
    "hex": "#D2CCCB"
  },
  {
    "name": "NCS S 2002-R",
    "hex": "#C4BEBE"
  },
  {
    "name": "NCS S 2502-R",
    "hex": "#BCB6B6"
  },
  {
    "name": "NCS S 3502-R",
    "hex": "#A4A1A0"
  },
  {
    "name": "NCS S 4502-R",
    "hex": "#918C8B"
  },
  {
    "name": "NCS S 5502-R",
    "hex": "#7D7777"
  },
  {
    "name": "NCS S 6502-R",
    "hex": "#686161"
  },
  {
    "name": "NCS S 7502-R",
    "hex": "#524B4B"
  },
  {
    "name": "NCS S 8502-R",
    "hex": "#322929"
  },
  {
    "name": "NCS S 0502-R50B",
    "hex": "#EBE9EB"
  },
  {
    "name": "NCS S 1002-R50B",
    "hex": "#DDDBDD"
  },
  {
    "name": "NCS S 1502-R50B",
    "hex": "#CFCDCF"
  },
  {
    "name": "NCS S 2002-R50B",
    "hex": "#C3C2C4"
  },
  {
    "name": "NCS S 0502-B",
    "hex": "#E7EDEE"
  },
  {
    "name": "NCS S 1002-B",
    "hex": "#D8DCDF"
  },
  {
    "name": "NCS S 1502-B",
    "hex": "#C9CFCF"
  },
  {
    "name": "NCS S 2002-B",
    "hex": "#BBC1C1"
  },
  {
    "name": "NCS S 2502-B",
    "hex": "#B2B9BB"
  },
  {
    "name": "NCS S 3502-B",
    "hex": "#9BA0A1"
  },
  {
    "name": "NCS S 4502-B",
    "hex": "#878B8F"
  },
  {
    "name": "NCS S 5502-B",
    "hex": "#737779"
  },
  {
    "name": "NCS S 6502-B",
    "hex": "#5D6365"
  },
  {
    "name": "NCS S 7502-B",
    "hex": "#484B4E"
  },
  {
    "name": "NCS S 8502-B",
    "hex": "#2B3134"
  },
  {
    "name": "NCS S 0502-B50G",
    "hex": "#E7EDEE"
  },
  {
    "name": "NCS S 1002-B50G",
    "hex": "#DADFDE"
  },
  {
    "name": "NCS S 1502-B50G",
    "hex": "#CCD1D0"
  },
  {
    "name": "NCS S 2002-B50G",
    "hex": "#BEC3C4"
  },
  {
    "name": "NCS S 0502-G",
    "hex": "#E6EBE7"
  },
  {
    "name": "NCS S 1002-G",
    "hex": "#DBDFDC"
  },
  {
    "name": "NCS S 1502-G",
    "hex": "#CACECB"
  },
  {
    "name": "NCS S 2002-G",
    "hex": "#BFC3C0"
  },
  {
    "name": "NCS S 2502-G",
    "hex": "#B1B6B3"
  },
  {
    "name": "NCS S 3502-G",
    "hex": "#99A19F"
  },
  {
    "name": "NCS S 4502-G",
    "hex": "#8A8E8B"
  },
  {
    "name": "NCS S 5502-G",
    "hex": "#757977"
  },
  {
    "name": "NCS S 6502-G",
    "hex": "#5F6665"
  },
  {
    "name": "NCS S 7502-G",
    "hex": "#494E4D"
  },
  {
    "name": "NCS S 8502-G",
    "hex": "#262D2A"
  },
  {
    "name": "NCS S 0502-G50Y",
    "hex": "#EBEDE4"
  },
  {
    "name": "NCS S 1002-G50Y",
    "hex": "#DCDFD8"
  },
  {
    "name": "NCS S 1502-G50Y",
    "hex": "#CED1CA"
  },
  {
    "name": "NCS S 2002-G50Y",
    "hex": "#C2C3BE"
  },
  {
    "name": "NCS S 0505-Y",
    "hex": "#F4EFDA"
  },
  {
    "name": "NCS S 0507-Y",
    "hex": "#F3ECD1"
  },
  {
    "name": "NCS S 0510-Y",
    "hex": "#F2E9C7"
  },
  {
    "name": "NCS S 0515-Y",
    "hex": "#F9ECBA"
  },
  {
    "name": "NCS S 0520-Y",
    "hex": "#F5E6AD"
  },
  {
    "name": "NCS S 0530-Y",
    "hex": "#FDE495"
  },
  {
    "name": "NCS S 0540-Y",
    "hex": "#FFE482"
  },
  {
    "name": "NCS S 0550-Y",
    "hex": "#F9D862"
  },
  {
    "name": "NCS S 0560-Y",
    "hex": "#FDD344"
  },
  {
    "name": "NCS S 0570-Y",
    "hex": "#FAD51F"
  },
  {
    "name": "NCS S 0580-Y",
    "hex": "#FFD100"
  },
  {
    "name": "NCS S 1005-Y",
    "hex": "#E3DEC9"
  },
  {
    "name": "NCS S 1010-Y",
    "hex": "#E4DBB9"
  },
  {
    "name": "NCS S 1015-Y",
    "hex": "#E9DAAD"
  },
  {
    "name": "NCS S 1020-Y",
    "hex": "#E8D7A1"
  },
  {
    "name": "NCS S 1030-Y",
    "hex": "#E3CF86"
  },
  {
    "name": "NCS S 1040-Y",
    "hex": "#EED375"
  },
  {
    "name": "NCS S 1050-Y",
    "hex": "#EDCD59"
  },
  {
    "name": "NCS S 1060-Y",
    "hex": "#F2CB3E"
  },
  {
    "name": "NCS S 1070-Y",
    "hex": "#EEC20C"
  },
  {
    "name": "NCS S 1080-Y",
    "hex": "#EABC00"
  },
  {
    "name": "NCS S 1505-Y",
    "hex": "#D4D0BD"
  },
  {
    "name": "NCS S 1510-Y",
    "hex": "#D5CDAD"
  },
  {
    "name": "NCS S 1515-Y",
    "hex": "#DACCA2"
  },
  {
    "name": "NCS S 2005-Y",
    "hex": "#C9C5B4"
  },
  {
    "name": "NCS S 2010-Y",
    "hex": "#C9BFA2"
  },
  {
    "name": "NCS S 2020-Y",
    "hex": "#CCBB8B"
  },
  {
    "name": "NCS S 2030-Y",
    "hex": "#C9B272"
  },
  {
    "name": "NCS S 2040-Y",
    "hex": "#D1B45E"
  },
  {
    "name": "NCS S 2050-Y",
    "hex": "#CAAC48"
  },
  {
    "name": "NCS S 2060-Y",
    "hex": "#C6A222"
  },
  {
    "name": "NCS S 2070-Y",
    "hex": "#C69F00"
  },
  {
    "name": "NCS S 3010-Y",
    "hex": "#B5A98B"
  },
  {
    "name": "NCS S 3020-Y",
    "hex": "#B3A375"
  },
  {
    "name": "NCS S 3030-Y",
    "hex": "#B49C61"
  },
  {
    "name": "NCS S 3040-Y",
    "hex": "#B2964B"
  },
  {
    "name": "NCS S 3050-Y",
    "hex": "#AC8A30"
  },
  {
    "name": "NCS S 3060-Y",
    "hex": "#AD8A20"
  },
  {
    "name": "NCS S 3560-Y",
    "hex": "#A07D0E"
  },
  {
    "name": "NCS S 4020-Y",
    "hex": "#9E8A61"
  },
  {
    "name": "NCS S 4030-Y",
    "hex": "#9C844D"
  },
  {
    "name": "NCS S 4040-Y",
    "hex": "#9A7E3D"
  },
  {
    "name": "NCS S 4050-Y",
    "hex": "#967929"
  },
  {
    "name": "NCS S 4550-Y",
    "hex": "#896911"
  },
  {
    "name": "NCS S 5020-Y",
    "hex": "#87734B"
  },
  {
    "name": "NCS S 5030-Y",
    "hex": "#866D38"
  },
  {
    "name": "NCS S 5040-Y",
    "hex": "#836728"
  },
  {
    "name": "NCS S 6020-Y",
    "hex": "#74623E"
  },
  {
    "name": "NCS S 6030-Y",
    "hex": "#6B5525"
  },
  {
    "name": "NCS S 7020-Y",
    "hex": "#564525"
  },
  {
    "name": "NCS S 0505-Y10R",
    "hex": "#F3ECD7"
  },
  {
    "name": "NCS S 0510-Y10R",
    "hex": "#FAEBC4"
  },
  {
    "name": "NCS S 0515-Y10R",
    "hex": "#FAE8B7"
  },
  {
    "name": "NCS S 0520-Y10R",
    "hex": "#FDE7AF"
  },
  {
    "name": "NCS S 0530-Y10R",
    "hex": "#FEDC92"
  },
  {
    "name": "NCS S 0540-Y10R",
    "hex": "#FFD87D"
  },
  {
    "name": "NCS S 0550-Y10R",
    "hex": "#FFD363"
  },
  {
    "name": "NCS S 0560-Y10R",
    "hex": "#FFCB48"
  },
  {
    "name": "NCS S 0570-Y10R",
    "hex": "#FFC703"
  },
  {
    "name": "NCS S 0580-Y10R",
    "hex": "#FFC200"
  },
  {
    "name": "NCS S 0804-Y10R",
    "hex": "#ECE6D5"
  },
  {
    "name": "NCS S 0907-Y10R",
    "hex": "#EAE0C4"
  },
  {
    "name": "NCS S 1005-Y10R",
    "hex": "#E1DBC8"
  },
  {
    "name": "NCS S 1010-Y10R",
    "hex": "#E5D7B4"
  },
  {
    "name": "NCS S 1015-Y10R",
    "hex": "#ECD9AE"
  },
  {
    "name": "NCS S 1020-Y10R",
    "hex": "#E7D09E"
  },
  {
    "name": "NCS S 1030-Y10R",
    "hex": "#EDCB86"
  },
  {
    "name": "NCS S 1040-Y10R",
    "hex": "#F4C96E"
  },
  {
    "name": "NCS S 1050-Y10R",
    "hex": "#F3C258"
  },
  {
    "name": "NCS S 1060-Y10R",
    "hex": "#F7BD3A"
  },
  {
    "name": "NCS S 1070-Y10R",
    "hex": "#F2B40E"
  },
  {
    "name": "NCS S 1080-Y10R",
    "hex": "#F5B300"
  },
  {
    "name": "NCS S 1505-Y10R",
    "hex": "#D6D0BD"
  },
  {
    "name": "NCS S 1510-Y10R",
    "hex": "#D9CCAB"
  },
  {
    "name": "NCS S 1515-Y10R",
    "hex": "#DDCBA2"
  },
  {
    "name": "NCS S 2005-Y10R",
    "hex": "#C8C2B0"
  },
  {
    "name": "NCS S 2010-Y10R",
    "hex": "#C8BB9D"
  },
  {
    "name": "NCS S 2020-Y10R",
    "hex": "#CDB78A"
  },
  {
    "name": "NCS S 2030-Y10R",
    "hex": "#D3B273"
  },
  {
    "name": "NCS S 2040-Y10R",
    "hex": "#D3AB5C"
  },
  {
    "name": "NCS S 2050-Y10R",
    "hex": "#D3A446"
  },
  {
    "name": "NCS S 2060-Y10R",
    "hex": "#D3A030"
  },
  {
    "name": "NCS S 2070-Y10R",
    "hex": "#D89B01"
  },
  {
    "name": "NCS S 3010-Y10R",
    "hex": "#B6A88D"
  },
  {
    "name": "NCS S 3020-Y10R",
    "hex": "#BDA378"
  },
  {
    "name": "NCS S 3030-Y10R",
    "hex": "#BD9C64"
  },
  {
    "name": "NCS S 3040-Y10R",
    "hex": "#BA934C"
  },
  {
    "name": "NCS S 3050-Y10R",
    "hex": "#B78933"
  },
  {
    "name": "NCS S 3060-Y10R",
    "hex": "#B7861B"
  },
  {
    "name": "NCS S 4010-Y10R",
    "hex": "#A3957B"
  },
  {
    "name": "NCS S 4020-Y10R",
    "hex": "#A18961"
  },
  {
    "name": "NCS S 4030-Y10R",
    "hex": "#A3824C"
  },
  {
    "name": "NCS S 4040-Y10R",
    "hex": "#A17835"
  },
  {
    "name": "NCS S 4050-Y10R",
    "hex": "#9C6F21"
  },
  {
    "name": "NCS S 4055-Y10R",
    "hex": "#A07521"
  },
  {
    "name": "NCS S 5010-Y10R",
    "hex": "#8F8069"
  },
  {
    "name": "NCS S 5020-Y10R",
    "hex": "#8A724D"
  },
  {
    "name": "NCS S 5030-Y10R",
    "hex": "#8E6D3B"
  },
  {
    "name": "NCS S 5040-Y10R",
    "hex": "#83601F"
  },
  {
    "name": "NCS S 6010-Y10R",
    "hex": "#776752"
  },
  {
    "name": "NCS S 6020-Y10R",
    "hex": "#765E3C"
  },
  {
    "name": "NCS S 6030-Y10R",
    "hex": "#6F5325"
  },
  {
    "name": "NCS S 7010-Y10R",
    "hex": "#625441"
  },
  {
    "name": "NCS S 7020-Y10R",
    "hex": "#5A4424"
  },
  {
    "name": "NCS S 8010-Y10R",
    "hex": "#463825"
  },
  {
    "name": "NCS S 0505-Y20R",
    "hex": "#F4ECD3"
  },
  {
    "name": "NCS S 0507-Y20R",
    "hex": "#F7EBCF"
  },
  {
    "name": "NCS S 0510-Y20R",
    "hex": "#F9E7C3"
  },
  {
    "name": "NCS S 0515-Y20R",
    "hex": "#FCE3B5"
  },
  {
    "name": "NCS S 0520-Y20R",
    "hex": "#FFDFA6"
  },
  {
    "name": "NCS S 0530-Y20R",
    "hex": "#FFD38F"
  },
  {
    "name": "NCS S 0540-Y20R",
    "hex": "#FFCD78"
  },
  {
    "name": "NCS S 0550-Y20R",
    "hex": "#FFC360"
  },
  {
    "name": "NCS S 0560-Y20R",
    "hex": "#FFBB48"
  },
  {
    "name": "NCS S 0570-Y20R",
    "hex": "#FFB422"
  },
  {
    "name": "NCS S 0580-Y20R",
    "hex": "#FFAB00"
  },
  {
    "name": "NCS S 0585-Y20R",
    "hex": "#FFAC00"
  },
  {
    "name": "NCS S 0603-Y20R",
    "hex": "#EEE9DA"
  },
  {
    "name": "NCS S 1005-Y20R",
    "hex": "#E4DAC4"
  },
  {
    "name": "NCS S 1010-Y20R",
    "hex": "#E8D6B6"
  },
  {
    "name": "NCS S 1015-Y20R",
    "hex": "#EDD5A9"
  },
  {
    "name": "NCS S 1020-Y20R",
    "hex": "#EDCE9C"
  },
  {
    "name": "NCS S 1030-Y20R",
    "hex": "#F4C886"
  },
  {
    "name": "NCS S 1040-Y20R",
    "hex": "#F6C06D"
  },
  {
    "name": "NCS S 1050-Y20R",
    "hex": "#F5B557"
  },
  {
    "name": "NCS S 1060-Y20R",
    "hex": "#FAAF3E"
  },
  {
    "name": "NCS S 1070-Y20R",
    "hex": "#F6A51F"
  },
  {
    "name": "NCS S 1080-Y20R",
    "hex": "#F29A00"
  },
  {
    "name": "NCS S 1505-Y20R",
    "hex": "#D8CFBD"
  },
  {
    "name": "NCS S 1510-Y20R",
    "hex": "#DDCBAC"
  },
  {
    "name": "NCS S 1515-Y20R",
    "hex": "#E0C69E"
  },
  {
    "name": "NCS S 2005-Y20R",
    "hex": "#C9C1B2"
  },
  {
    "name": "NCS S 2010-Y20R",
    "hex": "#CCBA9D"
  },
  {
    "name": "NCS S 2020-Y20R",
    "hex": "#D4B588"
  },
  {
    "name": "NCS S 2030-Y20R",
    "hex": "#D3AA72"
  },
  {
    "name": "NCS S 2040-Y20R",
    "hex": "#DBA45A"
  },
  {
    "name": "NCS S 2050-Y20R",
    "hex": "#D69B44"
  },
  {
    "name": "NCS S 2060-Y20R",
    "hex": "#D6932E"
  },
  {
    "name": "NCS S 2070-Y20R",
    "hex": "#D28905"
  },
  {
    "name": "NCS S 3005-Y20R",
    "hex": "#B3A898"
  },
  {
    "name": "NCS S 3010-Y20R",
    "hex": "#B5A58C"
  },
  {
    "name": "NCS S 3020-Y20R",
    "hex": "#B79A71"
  },
  {
    "name": "NCS S 3030-Y20R",
    "hex": "#B9935D"
  },
  {
    "name": "NCS S 3040-Y20R",
    "hex": "#BB8B49"
  },
  {
    "name": "NCS S 3050-Y20R",
    "hex": "#BB8336"
  },
  {
    "name": "NCS S 3060-Y20R",
    "hex": "#B97D20"
  },
  {
    "name": "NCS S 3065-Y20R",
    "hex": "#BA7813"
  },
  {
    "name": "NCS S 3560-Y20R",
    "hex": "#A86D10"
  },
  {
    "name": "NCS S 4005-Y20R",
    "hex": "#9E9383"
  },
  {
    "name": "NCS S 4020-Y20R",
    "hex": "#A58761"
  },
  {
    "name": "NCS S 4030-Y20R",
    "hex": "#A47D4C"
  },
  {
    "name": "NCS S 4040-Y20R",
    "hex": "#A3773C"
  },
  {
    "name": "NCS S 4050-Y20R",
    "hex": "#9F6A1F"
  },
  {
    "name": "NCS S 5005-Y20R",
    "hex": "#8B8173"
  },
  {
    "name": "NCS S 5020-Y20R",
    "hex": "#91724E"
  },
  {
    "name": "NCS S 5030-Y20R",
    "hex": "#8D6638"
  },
  {
    "name": "NCS S 5040-Y20R",
    "hex": "#8D5F26"
  },
  {
    "name": "NCS S 6005-Y20R",
    "hex": "#786C60"
  },
  {
    "name": "NCS S 6020-Y20R",
    "hex": "#775A3A"
  },
  {
    "name": "NCS S 6030-Y20R",
    "hex": "#755126"
  },
  {
    "name": "NCS S 7005-Y20R",
    "hex": "#5A5349"
  },
  {
    "name": "NCS S 7020-Y20R",
    "hex": "#60482C"
  },
  {
    "name": "NCS S 8005-Y20R",
    "hex": "#453E34"
  },
  {
    "name": "NCS S 8505-Y20R",
    "hex": "#332A20"
  },
  {
    "name": "NCS S 0505-Y30R",
    "hex": "#F8EAD3"
  },
  {
    "name": "NCS S 0510-Y30R",
    "hex": "#F9E3C4"
  },
  {
    "name": "NCS S 0515-Y30R",
    "hex": "#FBDBB1"
  },
  {
    "name": "NCS S 0520-Y30R",
    "hex": "#FDD7A9"
  },
  {
    "name": "NCS S 0530-Y30R",
    "hex": "#FFCB8C"
  },
  {
    "name": "NCS S 0540-Y30R",
    "hex": "#FFC177"
  },
  {
    "name": "NCS S 0550-Y30R",
    "hex": "#FFB562"
  },
  {
    "name": "NCS S 0560-Y30R",
    "hex": "#FFAE4E"
  },
  {
    "name": "NCS S 0570-Y30R",
    "hex": "#FFA030"
  },
  {
    "name": "NCS S 0580-Y30R",
    "hex": "#FF9800"
  },
  {
    "name": "NCS S 0585-Y30R",
    "hex": "#FF8F00"
  },
  {
    "name": "NCS S 0804-Y30R",
    "hex": "#EBE3D3"
  },
  {
    "name": "NCS S 0907-Y30R",
    "hex": "#ECDCC4"
  },
  {
    "name": "NCS S 1005-Y30R",
    "hex": "#E1D7C4"
  },
  {
    "name": "NCS S 1010-Y30R",
    "hex": "#EAD5B8"
  },
  {
    "name": "NCS S 1015-Y30R",
    "hex": "#EFD0A8"
  },
  {
    "name": "NCS S 1020-Y30R",
    "hex": "#F1C99A"
  },
  {
    "name": "NCS S 1030-Y30R",
    "hex": "#F4C085"
  },
  {
    "name": "NCS S 1040-Y30R",
    "hex": "#FAB66F"
  },
  {
    "name": "NCS S 1050-Y30R",
    "hex": "#F6A857"
  },
  {
    "name": "NCS S 1060-Y30R",
    "hex": "#F79F40"
  },
  {
    "name": "NCS S 1070-Y30R",
    "hex": "#F69326"
  },
  {
    "name": "NCS S 1080-Y30R",
    "hex": "#EE8600"
  },
  {
    "name": "NCS S 1505-Y30R",
    "hex": "#DACEBD"
  },
  {
    "name": "NCS S 1510-Y30R",
    "hex": "#DBC7AB"
  },
  {
    "name": "NCS S 1515-Y30R",
    "hex": "#E1C29D"
  },
  {
    "name": "NCS S 2005-Y30R",
    "hex": "#CBC1B2"
  },
  {
    "name": "NCS S 2010-Y30R",
    "hex": "#D2BFA5"
  },
  {
    "name": "NCS S 2020-Y30R",
    "hex": "#D7B38A"
  },
  {
    "name": "NCS S 2030-Y30R",
    "hex": "#D8A470"
  },
  {
    "name": "NCS S 2040-Y30R",
    "hex": "#DA9C5B"
  },
  {
    "name": "NCS S 2050-Y30R",
    "hex": "#D99146"
  },
  {
    "name": "NCS S 2060-Y30R",
    "hex": "#D58734"
  },
  {
    "name": "NCS S 2070-Y30R",
    "hex": "#D57E1D"
  },
  {
    "name": "NCS S 2570-Y30R",
    "hex": "#C57200"
  },
  {
    "name": "NCS S 3010-Y30R",
    "hex": "#B9A48A"
  },
  {
    "name": "NCS S 3020-Y30R",
    "hex": "#BC9873"
  },
  {
    "name": "NCS S 3030-Y30R",
    "hex": "#C08F61"
  },
  {
    "name": "NCS S 3040-Y30R",
    "hex": "#BC824B"
  },
  {
    "name": "NCS S 3050-Y30R",
    "hex": "#BD7A3A"
  },
  {
    "name": "NCS S 3060-Y30R",
    "hex": "#BB6F1C"
  },
  {
    "name": "NCS S 3560-Y30R",
    "hex": "#A96107"
  },
  {
    "name": "NCS S 4010-Y30R",
    "hex": "#A5917C"
  },
  {
    "name": "NCS S 4020-Y30R",
    "hex": "#A88665"
  },
  {
    "name": "NCS S 4030-Y30R",
    "hex": "#AB7A4E"
  },
  {
    "name": "NCS S 4040-Y30R",
    "hex": "#A46E3B"
  },
  {
    "name": "NCS S 4050-Y30R",
    "hex": "#A26427"
  },
  {
    "name": "NCS S 4550-Y30R",
    "hex": "#93581A"
  },
  {
    "name": "NCS S 5010-Y30R",
    "hex": "#8C7762"
  },
  {
    "name": "NCS S 5020-Y30R",
    "hex": "#8F6C4B"
  },
  {
    "name": "NCS S 5030-Y30R",
    "hex": "#8E623C"
  },
  {
    "name": "NCS S 5040-Y30R",
    "hex": "#8C5822"
  },
  {
    "name": "NCS S 6010-Y30R",
    "hex": "#7E6755"
  },
  {
    "name": "NCS S 6020-Y30R",
    "hex": "#76563A"
  },
  {
    "name": "NCS S 6030-Y30R",
    "hex": "#774F2B"
  },
  {
    "name": "NCS S 7010-Y30R",
    "hex": "#63503F"
  },
  {
    "name": "NCS S 7020-Y30R",
    "hex": "#5D3F24"
  },
  {
    "name": "NCS S 8010-Y30R",
    "hex": "#463525"
  },
  {
    "name": "NCS S 0505-Y40R",
    "hex": "#F9EAD7"
  },
  {
    "name": "NCS S 0507-Y40R",
    "hex": "#F7E7D0"
  },
  {
    "name": "NCS S 0510-Y40R",
    "hex": "#FCE2C4"
  },
  {
    "name": "NCS S 0515-Y40R",
    "hex": "#FEDAB7"
  },
  {
    "name": "NCS S 0520-Y40R",
    "hex": "#FFD2A8"
  },
  {
    "name": "NCS S 0530-Y40R",
    "hex": "#FFC590"
  },
  {
    "name": "NCS S 0540-Y40R",
    "hex": "#FFB578"
  },
  {
    "name": "NCS S 0550-Y40R",
    "hex": "#FFA963"
  },
  {
    "name": "NCS S 0560-Y40R",
    "hex": "#FFA350"
  },
  {
    "name": "NCS S 0570-Y40R",
    "hex": "#FF9033"
  },
  {
    "name": "NCS S 0580-Y40R",
    "hex": "#FE8401"
  },
  {
    "name": "NCS S 0585-Y40R",
    "hex": "#FB7D00"
  },
  {
    "name": "NCS S 0603-Y40R",
    "hex": "#F0E8DC"
  },
  {
    "name": "NCS S 1005-Y40R",
    "hex": "#E5DAC8"
  },
  {
    "name": "NCS S 1010-Y40R",
    "hex": "#EAD1B6"
  },
  {
    "name": "NCS S 1015-Y40R",
    "hex": "#EFCCAA"
  },
  {
    "name": "NCS S 1020-Y40R",
    "hex": "#F2C49B"
  },
  {
    "name": "NCS S 1030-Y40R",
    "hex": "#F7BB89"
  },
  {
    "name": "NCS S 1040-Y40R",
    "hex": "#F5AC71"
  },
  {
    "name": "NCS S 1050-Y40R",
    "hex": "#F5A05B"
  },
  {
    "name": "NCS S 1060-Y40R",
    "hex": "#F19145"
  },
  {
    "name": "NCS S 1070-Y40R",
    "hex": "#F48628"
  },
  {
    "name": "NCS S 1080-Y40R",
    "hex": "#EB7500"
  },
  {
    "name": "NCS S 1505-Y40R",
    "hex": "#D9CBBB"
  },
  {
    "name": "NCS S 1510-Y40R",
    "hex": "#DEC6AD"
  },
  {
    "name": "NCS S 1515-Y40R",
    "hex": "#E3C1A1"
  },
  {
    "name": "NCS S 2005-Y40R",
    "hex": "#CBBDAD"
  },
  {
    "name": "NCS S 2010-Y40R",
    "hex": "#D0B59B"
  },
  {
    "name": "NCS S 2020-Y40R",
    "hex": "#D2A987"
  },
  {
    "name": "NCS S 2030-Y40R",
    "hex": "#D79C71"
  },
  {
    "name": "NCS S 2040-Y40R",
    "hex": "#DB935D"
  },
  {
    "name": "NCS S 2050-Y40R",
    "hex": "#DB8B4C"
  },
  {
    "name": "NCS S 2060-Y40R",
    "hex": "#D47A34"
  },
  {
    "name": "NCS S 2070-Y40R",
    "hex": "#D16F24"
  },
  {
    "name": "NCS S 2570-Y40R",
    "hex": "#C5640E"
  },
  {
    "name": "NCS S 3010-Y40R",
    "hex": "#B9A08A"
  },
  {
    "name": "NCS S 3020-Y40R",
    "hex": "#BB9476"
  },
  {
    "name": "NCS S 3030-Y40R",
    "hex": "#BF885E"
  },
  {
    "name": "NCS S 3040-Y40R",
    "hex": "#BF7C4C"
  },
  {
    "name": "NCS S 3050-Y40R",
    "hex": "#C0743D"
  },
  {
    "name": "NCS S 3060-Y40R",
    "hex": "#B76429"
  },
  {
    "name": "NCS S 3560-Y40R",
    "hex": "#AA5B17"
  },
  {
    "name": "NCS S 4020-Y40R",
    "hex": "#A77F62"
  },
  {
    "name": "NCS S 4030-Y40R",
    "hex": "#A7704B"
  },
  {
    "name": "NCS S 4040-Y40R",
    "hex": "#A26338"
  },
  {
    "name": "NCS S 4050-Y40R",
    "hex": "#9F5922"
  },
  {
    "name": "NCS S 4550-Y40R",
    "hex": "#98501D"
  },
  {
    "name": "NCS S 5020-Y40R",
    "hex": "#916B4F"
  },
  {
    "name": "NCS S 5030-Y40R",
    "hex": "#8F5D3A"
  },
  {
    "name": "NCS S 5040-Y40R",
    "hex": "#8D5328"
  },
  {
    "name": "NCS S 6020-Y40R",
    "hex": "#7B543A"
  },
  {
    "name": "NCS S 6030-Y40R",
    "hex": "#744623"
  },
  {
    "name": "NCS S 7020-Y40R",
    "hex": "#624028"
  },
  {
    "name": "NCS S 0505-Y50R",
    "hex": "#F4E4D4"
  },
  {
    "name": "NCS S 0510-Y50R",
    "hex": "#FAE2CC"
  },
  {
    "name": "NCS S 0515-Y50R",
    "hex": "#FDD6B9"
  },
  {
    "name": "NCS S 0520-Y50R",
    "hex": "#FBCBA9"
  },
  {
    "name": "NCS S 0530-Y50R",
    "hex": "#FFC093"
  },
  {
    "name": "NCS S 0540-Y50R",
    "hex": "#FFB17D"
  },
  {
    "name": "NCS S 0550-Y50R",
    "hex": "#FFA068"
  },
  {
    "name": "NCS S 0560-Y50R",
    "hex": "#FF9658"
  },
  {
    "name": "NCS S 0570-Y50R",
    "hex": "#FB8134"
  },
  {
    "name": "NCS S 0580-Y50R",
    "hex": "#FF7815"
  },
  {
    "name": "NCS S 0585-Y50R",
    "hex": "#FF7400"
  },
  {
    "name": "NCS S 0804-Y50R",
    "hex": "#EADFD2"
  },
  {
    "name": "NCS S 0907-Y50R",
    "hex": "#EBD8C7"
  },
  {
    "name": "NCS S 1005-Y50R",
    "hex": "#E4D6C8"
  },
  {
    "name": "NCS S 1010-Y50R",
    "hex": "#EDD0BA"
  },
  {
    "name": "NCS S 1015-Y50R",
    "hex": "#EEC8AD"
  },
  {
    "name": "NCS S 1020-Y50R",
    "hex": "#F1C09E"
  },
  {
    "name": "NCS S 1030-Y50R",
    "hex": "#F9B58C"
  },
  {
    "name": "NCS S 1040-Y50R",
    "hex": "#F9A573"
  },
  {
    "name": "NCS S 1050-Y50R",
    "hex": "#F4975C"
  },
  {
    "name": "NCS S 1060-Y50R",
    "hex": "#F18749"
  },
  {
    "name": "NCS S 1070-Y50R",
    "hex": "#F07A31"
  },
  {
    "name": "NCS S 1080-Y50R",
    "hex": "#EB6A16"
  },
  {
    "name": "NCS S 1505-Y50R",
    "hex": "#D8CBBE"
  },
  {
    "name": "NCS S 1510-Y50R",
    "hex": "#DEC2AE"
  },
  {
    "name": "NCS S 1515-Y50R",
    "hex": "#E0BA9F"
  },
  {
    "name": "NCS S 2005-Y50R",
    "hex": "#C8BEB1"
  },
  {
    "name": "NCS S 2010-Y50R",
    "hex": "#D3B7A3"
  },
  {
    "name": "NCS S 2020-Y50R",
    "hex": "#D2A58A"
  },
  {
    "name": "NCS S 2030-Y50R",
    "hex": "#DB9A76"
  },
  {
    "name": "NCS S 2040-Y50R",
    "hex": "#D78C5E"
  },
  {
    "name": "NCS S 2050-Y50R",
    "hex": "#D87F4E"
  },
  {
    "name": "NCS S 2060-Y50R",
    "hex": "#D06F36"
  },
  {
    "name": "NCS S 2070-Y50R",
    "hex": "#D16520"
  },
  {
    "name": "NCS S 2570-Y50R",
    "hex": "#BF5A14"
  },
  {
    "name": "NCS S 3005-Y50R",
    "hex": "#B3A499"
  },
  {
    "name": "NCS S 3010-Y50R",
    "hex": "#BBA290"
  },
  {
    "name": "NCS S 3020-Y50R",
    "hex": "#C2957A"
  },
  {
    "name": "NCS S 3030-Y50R",
    "hex": "#C38662"
  },
  {
    "name": "NCS S 3040-Y50R",
    "hex": "#BF7850"
  },
  {
    "name": "NCS S 3050-Y50R",
    "hex": "#B7683D"
  },
  {
    "name": "NCS S 3060-Y50R",
    "hex": "#B55C25"
  },
  {
    "name": "NCS S 3560-Y50R",
    "hex": "#A85321"
  },
  {
    "name": "NCS S 4005-Y50R",
    "hex": "#9B9086"
  },
  {
    "name": "NCS S 4010-Y50R",
    "hex": "#A79080"
  },
  {
    "name": "NCS S 4020-Y50R",
    "hex": "#A97E64"
  },
  {
    "name": "NCS S 4030-Y50R",
    "hex": "#A96F4E"
  },
  {
    "name": "NCS S 4040-Y50R",
    "hex": "#A4623C"
  },
  {
    "name": "NCS S 4050-Y50R",
    "hex": "#9F5528"
  },
  {
    "name": "NCS S 4550-Y50R",
    "hex": "#934B25"
  },
  {
    "name": "NCS S 5005-Y50R",
    "hex": "#8B7D74"
  },
  {
    "name": "NCS S 5010-Y50R",
    "hex": "#8F7969"
  },
  {
    "name": "NCS S 5020-Y50R",
    "hex": "#916A56"
  },
  {
    "name": "NCS S 5030-Y50R",
    "hex": "#8E5A3E"
  },
  {
    "name": "NCS S 5040-Y50R",
    "hex": "#8B4C2C"
  },
  {
    "name": "NCS S 6005-Y50R",
    "hex": "#786961"
  },
  {
    "name": "NCS S 6010-Y50R",
    "hex": "#776051"
  },
  {
    "name": "NCS S 6020-Y50R",
    "hex": "#79513B"
  },
  {
    "name": "NCS S 6030-Y50R",
    "hex": "#754123"
  },
  {
    "name": "NCS S 7005-Y50R",
    "hex": "#62564F"
  },
  {
    "name": "NCS S 7010-Y50R",
    "hex": "#674E41"
  },
  {
    "name": "NCS S 7020-Y50R",
    "hex": "#5F3A25"
  },
  {
    "name": "NCS S 8005-Y50R",
    "hex": "#4A3C35"
  },
  {
    "name": "NCS S 8010-Y50R",
    "hex": "#463225"
  },
  {
    "name": "NCS S 0505-Y60R",
    "hex": "#F4E7DA"
  },
  {
    "name": "NCS S 0507-Y60R",
    "hex": "#F6E3D4"
  },
  {
    "name": "NCS S 0510-Y60R",
    "hex": "#FDE1CE"
  },
  {
    "name": "NCS S 0515-Y60R",
    "hex": "#FCD6BE"
  },
  {
    "name": "NCS S 0520-Y60R",
    "hex": "#FFCEB1"
  },
  {
    "name": "NCS S 0530-Y60R",
    "hex": "#FFBA97"
  },
  {
    "name": "NCS S 0540-Y60R",
    "hex": "#FFA982"
  },
  {
    "name": "NCS S 0550-Y60R",
    "hex": "#FF996D"
  },
  {
    "name": "NCS S 0560-Y60R",
    "hex": "#FF915E"
  },
  {
    "name": "NCS S 0570-Y60R",
    "hex": "#FF7D42"
  },
  {
    "name": "NCS S 0580-Y60R",
    "hex": "#F7641C"
  },
  {
    "name": "NCS S 0585-Y60R",
    "hex": "#F55B00"
  },
  {
    "name": "NCS S 0603-Y60R",
    "hex": "#F0E8E0"
  },
  {
    "name": "NCS S 1005-Y60R",
    "hex": "#E3D6C9"
  },
  {
    "name": "NCS S 1010-Y60R",
    "hex": "#E9CDBD"
  },
  {
    "name": "NCS S 1015-Y60R",
    "hex": "#EDC8B3"
  },
  {
    "name": "NCS S 1020-Y60R",
    "hex": "#ECBAA1"
  },
  {
    "name": "NCS S 1030-Y60R",
    "hex": "#F2B08F"
  },
  {
    "name": "NCS S 1040-Y60R",
    "hex": "#F6A27C"
  },
  {
    "name": "NCS S 1050-Y60R",
    "hex": "#F28E65"
  },
  {
    "name": "NCS S 1060-Y60R",
    "hex": "#EE7F52"
  },
  {
    "name": "NCS S 1070-Y60R",
    "hex": "#EA6F37"
  },
  {
    "name": "NCS S 1080-Y60R",
    "hex": "#E15700"
  },
  {
    "name": "NCS S 1505-Y60R",
    "hex": "#D9CAC0"
  },
  {
    "name": "NCS S 1510-Y60R",
    "hex": "#DCC3B2"
  },
  {
    "name": "NCS S 1515-Y60R",
    "hex": "#E0BAA5"
  },
  {
    "name": "NCS S 2005-Y60R",
    "hex": "#CCC0B5"
  },
  {
    "name": "NCS S 2010-Y60R",
    "hex": "#CFB5A4"
  },
  {
    "name": "NCS S 2020-Y60R",
    "hex": "#D1A68D"
  },
  {
    "name": "NCS S 2030-Y60R",
    "hex": "#DC997A"
  },
  {
    "name": "NCS S 2040-Y60R",
    "hex": "#D88765"
  },
  {
    "name": "NCS S 2050-Y60R",
    "hex": "#D47952"
  },
  {
    "name": "NCS S 2060-Y60R",
    "hex": "#D1683C"
  },
  {
    "name": "NCS S 2070-Y60R",
    "hex": "#C85725"
  },
  {
    "name": "NCS S 2075-Y60R",
    "hex": "#C9511C"
  },
  {
    "name": "NCS S 2570-Y60R",
    "hex": "#B94A13"
  },
  {
    "name": "NCS S 3010-Y60R",
    "hex": "#B69C8D"
  },
  {
    "name": "NCS S 3020-Y60R",
    "hex": "#BC907B"
  },
  {
    "name": "NCS S 3030-Y60R",
    "hex": "#C08367"
  },
  {
    "name": "NCS S 3040-Y60R",
    "hex": "#C07353"
  },
  {
    "name": "NCS S 3050-Y60R",
    "hex": "#B4613C"
  },
  {
    "name": "NCS S 3060-Y60R",
    "hex": "#B45325"
  },
  {
    "name": "NCS S 3560-Y60R",
    "hex": "#A1451B"
  },
  {
    "name": "NCS S 4020-Y60R",
    "hex": "#A87A65"
  },
  {
    "name": "NCS S 4030-Y60R",
    "hex": "#A5694F"
  },
  {
    "name": "NCS S 4040-Y60R",
    "hex": "#A25A3C"
  },
  {
    "name": "NCS S 4050-Y60R",
    "hex": "#9C4D2E"
  },
  {
    "name": "NCS S 4550-Y60R",
    "hex": "#8E4526"
  },
  {
    "name": "NCS S 5020-Y60R",
    "hex": "#916653"
  },
  {
    "name": "NCS S 5030-Y60R",
    "hex": "#8D533A"
  },
  {
    "name": "NCS S 5040-Y60R",
    "hex": "#83442A"
  },
  {
    "name": "NCS S 6020-Y60R",
    "hex": "#795140"
  },
  {
    "name": "NCS S 6030-Y60R",
    "hex": "#6E3920"
  },
  {
    "name": "NCS S 7020-Y60R",
    "hex": "#5D3726"
  },
  {
    "name": "NCS S 0505-Y70R",
    "hex": "#F5E7DE"
  },
  {
    "name": "NCS S 0510-Y70R",
    "hex": "#FCDDCD"
  },
  {
    "name": "NCS S 0515-Y70R",
    "hex": "#F9D3C1"
  },
  {
    "name": "NCS S 0520-Y70R",
    "hex": "#F9C8B4"
  },
  {
    "name": "NCS S 0530-Y70R",
    "hex": "#FFBBA2"
  },
  {
    "name": "NCS S 0540-Y70R",
    "hex": "#FFA487"
  },
  {
    "name": "NCS S 0550-Y70R",
    "hex": "#FF9775"
  },
  {
    "name": "NCS S 0560-Y70R",
    "hex": "#FA805F"
  },
  {
    "name": "NCS S 0570-Y70R",
    "hex": "#F76E49"
  },
  {
    "name": "NCS S 0580-Y70R",
    "hex": "#F45A33"
  },
  {
    "name": "NCS S 0585-Y70R",
    "hex": "#F24914"
  },
  {
    "name": "NCS S 0804-Y70R",
    "hex": "#EDE2DA"
  },
  {
    "name": "NCS S 0907-Y70R",
    "hex": "#EBD7CC"
  },
  {
    "name": "NCS S 1005-Y70R",
    "hex": "#E4D6CB"
  },
  {
    "name": "NCS S 1010-Y70R",
    "hex": "#EACDBD"
  },
  {
    "name": "NCS S 1015-Y70R",
    "hex": "#EDC4B4"
  },
  {
    "name": "NCS S 1020-Y70R",
    "hex": "#EDBDA9"
  },
  {
    "name": "NCS S 1030-Y70R",
    "hex": "#F1AC92"
  },
  {
    "name": "NCS S 1040-Y70R",
    "hex": "#F39A7F"
  },
  {
    "name": "NCS S 1050-Y70R",
    "hex": "#F38966"
  },
  {
    "name": "NCS S 1060-Y70R",
    "hex": "#ED7655"
  },
  {
    "name": "NCS S 1070-Y70R",
    "hex": "#E86541"
  },
  {
    "name": "NCS S 1080-Y70R",
    "hex": "#DE4D21"
  },
  {
    "name": "NCS S 1505-Y70R",
    "hex": "#D6CBC4"
  },
  {
    "name": "NCS S 1510-Y70R",
    "hex": "#D9C0B3"
  },
  {
    "name": "NCS S 1515-Y70R",
    "hex": "#DDB7A6"
  },
  {
    "name": "NCS S 2005-Y70R",
    "hex": "#CBBDB5"
  },
  {
    "name": "NCS S 2010-Y70R",
    "hex": "#D0B4A8"
  },
  {
    "name": "NCS S 2020-Y70R",
    "hex": "#D8A696"
  },
  {
    "name": "NCS S 2030-Y70R",
    "hex": "#DB9581"
  },
  {
    "name": "NCS S 2040-Y70R",
    "hex": "#D5846A"
  },
  {
    "name": "NCS S 2050-Y70R",
    "hex": "#D17155"
  },
  {
    "name": "NCS S 2060-Y70R",
    "hex": "#CD6143"
  },
  {
    "name": "NCS S 2070-Y70R",
    "hex": "#C54929"
  },
  {
    "name": "NCS S 2075-Y70R",
    "hex": "#BE4427"
  },
  {
    "name": "NCS S 2570-Y70R",
    "hex": "#AE3D21"
  },
  {
    "name": "NCS S 3010-Y70R",
    "hex": "#B79C90"
  },
  {
    "name": "NCS S 3020-Y70R",
    "hex": "#BF9281"
  },
  {
    "name": "NCS S 3030-Y70R",
    "hex": "#BD7C68"
  },
  {
    "name": "NCS S 3040-Y70R",
    "hex": "#B96E56"
  },
  {
    "name": "NCS S 3050-Y70R",
    "hex": "#B4573F"
  },
  {
    "name": "NCS S 3060-Y70R",
    "hex": "#AA472C"
  },
  {
    "name": "NCS S 3560-Y70R",
    "hex": "#9C391F"
  },
  {
    "name": "NCS S 4010-Y70R",
    "hex": "#A48A80"
  },
  {
    "name": "NCS S 4020-Y70R",
    "hex": "#A3786A"
  },
  {
    "name": "NCS S 4030-Y70R",
    "hex": "#A66856"
  },
  {
    "name": "NCS S 4040-Y70R",
    "hex": "#9F5744"
  },
  {
    "name": "NCS S 4050-Y70R",
    "hex": "#994229"
  },
  {
    "name": "NCS S 4550-Y70R",
    "hex": "#893B24"
  },
  {
    "name": "NCS S 5010-Y70R",
    "hex": "#8E7268"
  },
  {
    "name": "NCS S 5020-Y70R",
    "hex": "#926659"
  },
  {
    "name": "NCS S 5030-Y70R",
    "hex": "#8C5341"
  },
  {
    "name": "NCS S 5040-Y70R",
    "hex": "#813D26"
  },
  {
    "name": "NCS S 6010-Y70R",
    "hex": "#775F58"
  },
  {
    "name": "NCS S 6020-Y70R",
    "hex": "#784E40"
  },
  {
    "name": "NCS S 6030-Y70R",
    "hex": "#6D3523"
  },
  {
    "name": "NCS S 7010-Y70R",
    "hex": "#5D453D"
  },
  {
    "name": "NCS S 7020-Y70R",
    "hex": "#5B3124"
  },
  {
    "name": "NCS S 8010-Y70R",
    "hex": "#43291D"
  },
  {
    "name": "NCS S 0505-Y80R",
    "hex": "#F4E7E0"
  },
  {
    "name": "NCS S 0507-Y80R",
    "hex": "#F9E5DE"
  },
  {
    "name": "NCS S 0510-Y80R",
    "hex": "#FADDD3"
  },
  {
    "name": "NCS S 0515-Y80R",
    "hex": "#FDD5CA"
  },
  {
    "name": "NCS S 0520-Y80R",
    "hex": "#FFCDBF"
  },
  {
    "name": "NCS S 0530-Y80R",
    "hex": "#FFBBAB"
  },
  {
    "name": "NCS S 0540-Y80R",
    "hex": "#FFA492"
  },
  {
    "name": "NCS S 0550-Y80R",
    "hex": "#FF8F7D"
  },
  {
    "name": "NCS S 0560-Y80R",
    "hex": "#FF7B6B"
  },
  {
    "name": "NCS S 0570-Y80R",
    "hex": "#F7624E"
  },
  {
    "name": "NCS S 0580-Y80R",
    "hex": "#EB4A36"
  },
  {
    "name": "NCS S 0585-Y80R",
    "hex": "#E92B14"
  },
  {
    "name": "NCS S 0603-Y80R",
    "hex": "#EFE8E4"
  },
  {
    "name": "NCS S 1005-Y80R",
    "hex": "#E3D6CF"
  },
  {
    "name": "NCS S 1010-Y80R",
    "hex": "#E7CDC4"
  },
  {
    "name": "NCS S 1015-Y80R",
    "hex": "#EBC4B9"
  },
  {
    "name": "NCS S 1020-Y80R",
    "hex": "#EEBCAF"
  },
  {
    "name": "NCS S 1030-Y80R",
    "hex": "#EBA696"
  },
  {
    "name": "NCS S 1040-Y80R",
    "hex": "#F29686"
  },
  {
    "name": "NCS S 1050-Y80R",
    "hex": "#F18573"
  },
  {
    "name": "NCS S 1060-Y80R",
    "hex": "#E96D5C"
  },
  {
    "name": "NCS S 1070-Y80R",
    "hex": "#E35947"
  },
  {
    "name": "NCS S 1080-Y80R",
    "hex": "#DA3C2A"
  },
  {
    "name": "NCS S 1085-Y80R",
    "hex": "#D72F1E"
  },
  {
    "name": "NCS S 1505-Y80R",
    "hex": "#D7CBC6"
  },
  {
    "name": "NCS S 1510-Y80R",
    "hex": "#D8C0B6"
  },
  {
    "name": "NCS S 1515-Y80R",
    "hex": "#E0B9AE"
  },
  {
    "name": "NCS S 1580-Y80R",
    "hex": "#C42D20"
  },
  {
    "name": "NCS S 2005-Y80R",
    "hex": "#C7BAB6"
  },
  {
    "name": "NCS S 2010-Y80R",
    "hex": "#CCB1A9"
  },
  {
    "name": "NCS S 2020-Y80R",
    "hex": "#CFA296"
  },
  {
    "name": "NCS S 2030-Y80R",
    "hex": "#D58F81"
  },
  {
    "name": "NCS S 2040-Y80R",
    "hex": "#D57F70"
  },
  {
    "name": "NCS S 2050-Y80R",
    "hex": "#D06C5C"
  },
  {
    "name": "NCS S 2060-Y80R",
    "hex": "#CA5446"
  },
  {
    "name": "NCS S 2070-Y80R",
    "hex": "#BB3A2C"
  },
  {
    "name": "NCS S 2570-Y80R",
    "hex": "#A82A1F"
  },
  {
    "name": "NCS S 3005-Y80R",
    "hex": "#B4A7A1"
  },
  {
    "name": "NCS S 3010-Y80R",
    "hex": "#B49D94"
  },
  {
    "name": "NCS S 3020-Y80R",
    "hex": "#B88D83"
  },
  {
    "name": "NCS S 3030-Y80R",
    "hex": "#B7766C"
  },
  {
    "name": "NCS S 3040-Y80R",
    "hex": "#B9695C"
  },
  {
    "name": "NCS S 3050-Y80R",
    "hex": "#AE5145"
  },
  {
    "name": "NCS S 3060-Y80R",
    "hex": "#A73F30"
  },
  {
    "name": "NCS S 3560-Y80R",
    "hex": "#943027"
  },
  {
    "name": "NCS S 4005-Y80R",
    "hex": "#A0928E"
  },
  {
    "name": "NCS S 4020-Y80R",
    "hex": "#A3746B"
  },
  {
    "name": "NCS S 4030-Y80R",
    "hex": "#A2665A"
  },
  {
    "name": "NCS S 4040-Y80R",
    "hex": "#9D5046"
  },
  {
    "name": "NCS S 4050-Y80R",
    "hex": "#8F3A2D"
  },
  {
    "name": "NCS S 4550-Y80R",
    "hex": "#822D22"
  },
  {
    "name": "NCS S 5005-Y80R",
    "hex": "#897E79"
  },
  {
    "name": "NCS S 5020-Y80R",
    "hex": "#8C6157"
  },
  {
    "name": "NCS S 5030-Y80R",
    "hex": "#884C43"
  },
  {
    "name": "NCS S 5040-Y80R",
    "hex": "#7A342B"
  },
  {
    "name": "NCS S 6005-Y80R",
    "hex": "#756A65"
  },
  {
    "name": "NCS S 6020-Y80R",
    "hex": "#754B44"
  },
  {
    "name": "NCS S 6030-Y80R",
    "hex": "#6B322B"
  },
  {
    "name": "NCS S 7005-Y80R",
    "hex": "#5E514E"
  },
  {
    "name": "NCS S 7020-Y80R",
    "hex": "#572B23"
  },
  {
    "name": "NCS S 8005-Y80R",
    "hex": "#463733"
  },
  {
    "name": "NCS S 8505-Y80R",
    "hex": "#332622"
  },
  {
    "name": "NCS S 0505-Y90R",
    "hex": "#F4E7E2"
  },
  {
    "name": "NCS S 0510-Y90R",
    "hex": "#F7DED7"
  },
  {
    "name": "NCS S 0515-Y90R",
    "hex": "#F7D3CB"
  },
  {
    "name": "NCS S 0520-Y90R",
    "hex": "#FBCAC2"
  },
  {
    "name": "NCS S 0530-Y90R",
    "hex": "#FEB9B0"
  },
  {
    "name": "NCS S 0540-Y90R",
    "hex": "#FFA49C"
  },
  {
    "name": "NCS S 0550-Y90R",
    "hex": "#F58A83"
  },
  {
    "name": "NCS S 0560-Y90R",
    "hex": "#F5726E"
  },
  {
    "name": "NCS S 0570-Y90R",
    "hex": "#EC5A57"
  },
  {
    "name": "NCS S 0580-Y90R",
    "hex": "#E7373B"
  },
  {
    "name": "NCS S 0804-Y90R",
    "hex": "#E9DFDB"
  },
  {
    "name": "NCS S 0907-Y90R",
    "hex": "#EAD7D2"
  },
  {
    "name": "NCS S 1005-Y90R",
    "hex": "#E3D6D1"
  },
  {
    "name": "NCS S 1010-Y90R",
    "hex": "#E8D0CB"
  },
  {
    "name": "NCS S 1015-Y90R",
    "hex": "#EAC4BD"
  },
  {
    "name": "NCS S 1020-Y90R",
    "hex": "#EABDB6"
  },
  {
    "name": "NCS S 1030-Y90R",
    "hex": "#E9A69F"
  },
  {
    "name": "NCS S 1040-Y90R",
    "hex": "#EF978F"
  },
  {
    "name": "NCS S 1050-Y90R",
    "hex": "#EB7F7A"
  },
  {
    "name": "NCS S 1060-Y90R",
    "hex": "#E66A66"
  },
  {
    "name": "NCS S 1070-Y90R",
    "hex": "#DE4B4C"
  },
  {
    "name": "NCS S 1080-Y90R",
    "hex": "#CF1E2B"
  },
  {
    "name": "NCS S 1085-Y90R",
    "hex": "#CE1526"
  },
  {
    "name": "NCS S 1505-Y90R",
    "hex": "#D4C8C5"
  },
  {
    "name": "NCS S 1510-Y90R",
    "hex": "#D5BDB7"
  },
  {
    "name": "NCS S 1515-Y90R",
    "hex": "#DCB7AF"
  },
  {
    "name": "NCS S 1580-Y90R",
    "hex": "#BB1520"
  },
  {
    "name": "NCS S 2005-Y90R",
    "hex": "#C9BDBA"
  },
  {
    "name": "NCS S 2010-Y90R",
    "hex": "#CAB2AB"
  },
  {
    "name": "NCS S 2020-Y90R",
    "hex": "#D4A39C"
  },
  {
    "name": "NCS S 2030-Y90R",
    "hex": "#D18D88"
  },
  {
    "name": "NCS S 2040-Y90R",
    "hex": "#CF7E78"
  },
  {
    "name": "NCS S 2050-Y90R",
    "hex": "#CD6962"
  },
  {
    "name": "NCS S 2060-Y90R",
    "hex": "#C44E4B"
  },
  {
    "name": "NCS S 2070-Y90R",
    "hex": "#B63334"
  },
  {
    "name": "NCS S 2570-Y90R",
    "hex": "#A12425"
  },
  {
    "name": "NCS S 3010-Y90R",
    "hex": "#B39D97"
  },
  {
    "name": "NCS S 3020-Y90R",
    "hex": "#B68984"
  },
  {
    "name": "NCS S 3030-Y90R",
    "hex": "#B77671"
  },
  {
    "name": "NCS S 3040-Y90R",
    "hex": "#B4635C"
  },
  {
    "name": "NCS S 3050-Y90R",
    "hex": "#AF504A"
  },
  {
    "name": "NCS S 3060-Y90R",
    "hex": "#A03432"
  },
  {
    "name": "NCS S 3560-Y90R",
    "hex": "#882626"
  },
  {
    "name": "NCS S 4010-Y90R",
    "hex": "#9E8883"
  },
  {
    "name": "NCS S 4020-Y90R",
    "hex": "#A37874"
  },
  {
    "name": "NCS S 4030-Y90R",
    "hex": "#9F625F"
  },
  {
    "name": "NCS S 4040-Y90R",
    "hex": "#9E4F4A"
  },
  {
    "name": "NCS S 4050-Y90R",
    "hex": "#89312D"
  },
  {
    "name": "NCS S 4550-Y90R",
    "hex": "#752425"
  },
  {
    "name": "NCS S 5010-Y90R",
    "hex": "#88706C"
  },
  {
    "name": "NCS S 5020-Y90R",
    "hex": "#8A5E5A"
  },
  {
    "name": "NCS S 5030-Y90R",
    "hex": "#834B47"
  },
  {
    "name": "NCS S 5040-Y90R",
    "hex": "#722D2B"
  },
  {
    "name": "NCS S 5540-Y90R",
    "hex": "#682221"
  },
  {
    "name": "NCS S 6010-Y90R",
    "hex": "#775F5B"
  },
  {
    "name": "NCS S 6020-Y90R",
    "hex": "#734C49"
  },
  {
    "name": "NCS S 6030-Y90R",
    "hex": "#642B28"
  },
  {
    "name": "NCS S 7010-Y90R",
    "hex": "#604642"
  },
  {
    "name": "NCS S 7020-Y90R",
    "hex": "#4F2521"
  },
  {
    "name": "NCS S 8010-Y90R",
    "hex": "#3F2724"
  },
  {
    "name": "NCS S 0505-R",
    "hex": "#F3E7E4"
  },
  {
    "name": "NCS S 0507-R",
    "hex": "#F4E3E1"
  },
  {
    "name": "NCS S 0510-R",
    "hex": "#F5DBD8"
  },
  {
    "name": "NCS S 0515-R",
    "hex": "#F5D3D0"
  },
  {
    "name": "NCS S 0520-R",
    "hex": "#F6C7C5"
  },
  {
    "name": "NCS S 0530-R",
    "hex": "#F9B6B6"
  },
  {
    "name": "NCS S 0540-R",
    "hex": "#FAA1A2"
  },
  {
    "name": "NCS S 0550-R",
    "hex": "#F4868B"
  },
  {
    "name": "NCS S 0560-R",
    "hex": "#EF7179"
  },
  {
    "name": "NCS S 0565-R",
    "hex": "#EA606B"
  },
  {
    "name": "NCS S 1005-R",
    "hex": "#DFD3D0"
  },
  {
    "name": "NCS S 1010-R",
    "hex": "#E0CBC9"
  },
  {
    "name": "NCS S 1015-R",
    "hex": "#E6C2C0"
  },
  {
    "name": "NCS S 1020-R",
    "hex": "#E9B9B9"
  },
  {
    "name": "NCS S 1030-R",
    "hex": "#EAA9AB"
  },
  {
    "name": "NCS S 1040-R",
    "hex": "#EB9497"
  },
  {
    "name": "NCS S 1050-R",
    "hex": "#E57D81"
  },
  {
    "name": "NCS S 1060-R",
    "hex": "#E0646F"
  },
  {
    "name": "NCS S 1070-R",
    "hex": "#D63F4F"
  },
  {
    "name": "NCS S 1080-R",
    "hex": "#C20633"
  },
  {
    "name": "NCS S 1510-R",
    "hex": "#D6C0BE"
  },
  {
    "name": "NCS S 1515-R",
    "hex": "#DBB7B5"
  },
  {
    "name": "NCS S 1580-R",
    "hex": "#AB0028"
  },
  {
    "name": "NCS S 2005-R",
    "hex": "#C8BDBC"
  },
  {
    "name": "NCS S 2010-R",
    "hex": "#C9B6B3"
  },
  {
    "name": "NCS S 2020-R",
    "hex": "#CCA2A2"
  },
  {
    "name": "NCS S 2030-R",
    "hex": "#CF8D8F"
  },
  {
    "name": "NCS S 2040-R",
    "hex": "#CE797D"
  },
  {
    "name": "NCS S 2050-R",
    "hex": "#CC656A"
  },
  {
    "name": "NCS S 2060-R",
    "hex": "#BE4751"
  },
  {
    "name": "NCS S 2070-R",
    "hex": "#AF1A34"
  },
  {
    "name": "NCS S 2570-R",
    "hex": "#910521"
  },
  {
    "name": "NCS S 3010-R",
    "hex": "#B19A98"
  },
  {
    "name": "NCS S 3020-R",
    "hex": "#B38A8B"
  },
  {
    "name": "NCS S 3030-R",
    "hex": "#B47779"
  },
  {
    "name": "NCS S 3040-R",
    "hex": "#B36367"
  },
  {
    "name": "NCS S 3050-R",
    "hex": "#A94B53"
  },
  {
    "name": "NCS S 3060-R",
    "hex": "#922333"
  },
  {
    "name": "NCS S 3560-R",
    "hex": "#801223"
  },
  {
    "name": "NCS S 4020-R",
    "hex": "#9E7272"
  },
  {
    "name": "NCS S 4030-R",
    "hex": "#9A5D5F"
  },
  {
    "name": "NCS S 4040-R",
    "hex": "#98494D"
  },
  {
    "name": "NCS S 4050-R",
    "hex": "#892A32"
  },
  {
    "name": "NCS S 5020-R",
    "hex": "#865C5C"
  },
  {
    "name": "NCS S 5030-R",
    "hex": "#7C4247"
  },
  {
    "name": "NCS S 5040-R",
    "hex": "#742932"
  },
  {
    "name": "NCS S 6020-R",
    "hex": "#6E4345"
  },
  {
    "name": "NCS S 6030-R",
    "hex": "#5E2629"
  },
  {
    "name": "NCS S 7020-R",
    "hex": "#4F2929"
  },
  {
    "name": "NCS S 0505-R10B",
    "hex": "#EFE4E5"
  },
  {
    "name": "NCS S 0510-R10B",
    "hex": "#F5DEDE"
  },
  {
    "name": "NCS S 0515-R10B",
    "hex": "#F4D3D6"
  },
  {
    "name": "NCS S 0520-R10B",
    "hex": "#F3C8CC"
  },
  {
    "name": "NCS S 0530-R10B",
    "hex": "#F7B6C0"
  },
  {
    "name": "NCS S 0540-R10B",
    "hex": "#F8A2AF"
  },
  {
    "name": "NCS S 0550-R10B",
    "hex": "#F18B9C"
  },
  {
    "name": "NCS S 0804-R10B",
    "hex": "#E9DEDF"
  },
  {
    "name": "NCS S 0907-R10B",
    "hex": "#E5D5D5"
  },
  {
    "name": "NCS S 1005-R10B",
    "hex": "#E1D6D7"
  },
  {
    "name": "NCS S 1010-R10B",
    "hex": "#E3CECF"
  },
  {
    "name": "NCS S 1015-R10B",
    "hex": "#E5C5C8"
  },
  {
    "name": "NCS S 1020-R10B",
    "hex": "#E4BABE"
  },
  {
    "name": "NCS S 1030-R10B",
    "hex": "#E7AAB2"
  },
  {
    "name": "NCS S 1040-R10B",
    "hex": "#E0909C"
  },
  {
    "name": "NCS S 1050-R10B",
    "hex": "#E77F90"
  },
  {
    "name": "NCS S 1060-R10B",
    "hex": "#E1627B"
  },
  {
    "name": "NCS S 1070-R10B",
    "hex": "#D53E61"
  },
  {
    "name": "NCS S 1510-R10B",
    "hex": "#D5C0C2"
  },
  {
    "name": "NCS S 1515-R10B",
    "hex": "#D7B8BA"
  },
  {
    "name": "NCS S 1575-R10B",
    "hex": "#B70645"
  },
  {
    "name": "NCS S 2005-R10B",
    "hex": "#C8BDBE"
  },
  {
    "name": "NCS S 2010-R10B",
    "hex": "#C7B2B4"
  },
  {
    "name": "NCS S 2020-R10B",
    "hex": "#CAA2A8"
  },
  {
    "name": "NCS S 2030-R10B",
    "hex": "#CB8E99"
  },
  {
    "name": "NCS S 2040-R10B",
    "hex": "#C97787"
  },
  {
    "name": "NCS S 2050-R10B",
    "hex": "#C26171"
  },
  {
    "name": "NCS S 2060-R10B",
    "hex": "#BB3D5B"
  },
  {
    "name": "NCS S 2070-R10B",
    "hex": "#A7123F"
  },
  {
    "name": "NCS S 3010-R10B",
    "hex": "#B19D9F"
  },
  {
    "name": "NCS S 3020-R10B",
    "hex": "#B28A90"
  },
  {
    "name": "NCS S 3030-R10B",
    "hex": "#B17880"
  },
  {
    "name": "NCS S 3040-R10B",
    "hex": "#AC5E6A"
  },
  {
    "name": "NCS S 3050-R10B",
    "hex": "#A54257"
  },
  {
    "name": "NCS S 3060-R10B",
    "hex": "#94153A"
  },
  {
    "name": "NCS S 4010-R10B",
    "hex": "#9E878A"
  },
  {
    "name": "NCS S 4020-R10B",
    "hex": "#9E757C"
  },
  {
    "name": "NCS S 4030-R10B",
    "hex": "#975E67"
  },
  {
    "name": "NCS S 4040-R10B",
    "hex": "#914552"
  },
  {
    "name": "NCS S 4050-R10B",
    "hex": "#791D33"
  },
  {
    "name": "NCS S 5010-R10B",
    "hex": "#877477"
  },
  {
    "name": "NCS S 5020-R10B",
    "hex": "#895E64"
  },
  {
    "name": "NCS S 5030-R10B",
    "hex": "#804850"
  },
  {
    "name": "NCS S 5040-R10B",
    "hex": "#6B2232"
  },
  {
    "name": "NCS S 6010-R10B",
    "hex": "#715D61"
  },
  {
    "name": "NCS S 6020-R10B",
    "hex": "#6F464E"
  },
  {
    "name": "NCS S 6030-R10B",
    "hex": "#5C222D"
  },
  {
    "name": "NCS S 7010-R10B",
    "hex": "#5A3E42"
  },
  {
    "name": "NCS S 7020-R10B",
    "hex": "#4C262E"
  },
  {
    "name": "NCS S 8010-R10B",
    "hex": "#392025"
  },
  {
    "name": "NCS S 0505-R20B",
    "hex": "#EEE4E7"
  },
  {
    "name": "NCS S 0507-R20B",
    "hex": "#EFE0E4"
  },
  {
    "name": "NCS S 0510-R20B",
    "hex": "#F1DCDF"
  },
  {
    "name": "NCS S 0515-R20B",
    "hex": "#F0D4DC"
  },
  {
    "name": "NCS S 0520-R20B",
    "hex": "#F2CCD4"
  },
  {
    "name": "NCS S 0530-R20B",
    "hex": "#F7BECE"
  },
  {
    "name": "NCS S 0540-R20B",
    "hex": "#F2A3BA"
  },
  {
    "name": "NCS S 0603-R20B",
    "hex": "#ECE5E7"
  },
  {
    "name": "NCS S 1005-R20B",
    "hex": "#DDD3D6"
  },
  {
    "name": "NCS S 1010-R20B",
    "hex": "#DFCBD0"
  },
  {
    "name": "NCS S 1015-R20B",
    "hex": "#E4C6CE"
  },
  {
    "name": "NCS S 1020-R20B",
    "hex": "#E2BBC6"
  },
  {
    "name": "NCS S 1030-R20B",
    "hex": "#E0A8B7"
  },
  {
    "name": "NCS S 1040-R20B",
    "hex": "#E694AC"
  },
  {
    "name": "NCS S 1050-R20B",
    "hex": "#DF7A9A"
  },
  {
    "name": "NCS S 1060-R20B",
    "hex": "#D95C85"
  },
  {
    "name": "NCS S 1070-R20B",
    "hex": "#D13A71"
  },
  {
    "name": "NCS S 1510-R20B",
    "hex": "#D4C0C5"
  },
  {
    "name": "NCS S 1515-R20B",
    "hex": "#D6B8C0"
  },
  {
    "name": "NCS S 2005-R20B",
    "hex": "#C4BABD"
  },
  {
    "name": "NCS S 2010-R20B",
    "hex": "#C6B2B8"
  },
  {
    "name": "NCS S 2020-R20B",
    "hex": "#C6A0AB"
  },
  {
    "name": "NCS S 2030-R20B",
    "hex": "#C88FA2"
  },
  {
    "name": "NCS S 2040-R20B",
    "hex": "#C7778F"
  },
  {
    "name": "NCS S 2050-R20B",
    "hex": "#C86083"
  },
  {
    "name": "NCS S 2060-R20B",
    "hex": "#B83F6A"
  },
  {
    "name": "NCS S 2065-R20B",
    "hex": "#AA1D5B"
  },
  {
    "name": "NCS S 3005-R20B",
    "hex": "#B1A7AA"
  },
  {
    "name": "NCS S 3010-R20B",
    "hex": "#B09DA2"
  },
  {
    "name": "NCS S 3020-R20B",
    "hex": "#B08B95"
  },
  {
    "name": "NCS S 3030-R20B",
    "hex": "#AD7588"
  },
  {
    "name": "NCS S 3040-R20B",
    "hex": "#AB5E74"
  },
  {
    "name": "NCS S 3050-R20B",
    "hex": "#A54162"
  },
  {
    "name": "NCS S 3060-R20B",
    "hex": "#8E1548"
  },
  {
    "name": "NCS S 4005-R20B",
    "hex": "#978D90"
  },
  {
    "name": "NCS S 4020-R20B",
    "hex": "#9A737E"
  },
  {
    "name": "NCS S 4030-R20B",
    "hex": "#975D70"
  },
  {
    "name": "NCS S 4040-R20B",
    "hex": "#92435D"
  },
  {
    "name": "NCS S 4050-R20B",
    "hex": "#7E1B40"
  },
  {
    "name": "NCS S 5005-R20B",
    "hex": "#887D82"
  },
  {
    "name": "NCS S 5020-R20B",
    "hex": "#835C68"
  },
  {
    "name": "NCS S 5030-R20B",
    "hex": "#76394C"
  },
  {
    "name": "NCS S 5040-R20B",
    "hex": "#681937"
  },
  {
    "name": "NCS S 6005-R20B",
    "hex": "#73666B"
  },
  {
    "name": "NCS S 6020-R20B",
    "hex": "#673E4B"
  },
  {
    "name": "NCS S 6030-R20B",
    "hex": "#5C1D34"
  },
  {
    "name": "NCS S 7005-R20B",
    "hex": "#605356"
  },
  {
    "name": "NCS S 7020-R20B",
    "hex": "#481C2E"
  },
  {
    "name": "NCS S 8005-R20B",
    "hex": "#3F3338"
  },
  {
    "name": "NCS S 8505-R20B",
    "hex": "#2C2026"
  },
  {
    "name": "NCS S 0505-R30B",
    "hex": "#F1E7EB"
  },
  {
    "name": "NCS S 0510-R30B",
    "hex": "#F1DFE6"
  },
  {
    "name": "NCS S 0520-R30B",
    "hex": "#F3CFDD"
  },
  {
    "name": "NCS S 0530-R30B",
    "hex": "#EDB9D0"
  },
  {
    "name": "NCS S 0540-R30B",
    "hex": "#EFA7CB"
  },
  {
    "name": "NCS S 0804-R30B",
    "hex": "#E6DFE3"
  },
  {
    "name": "NCS S 0907-R30B",
    "hex": "#E4D8DD"
  },
  {
    "name": "NCS S 1005-R30B",
    "hex": "#E0D6DA"
  },
  {
    "name": "NCS S 1010-R30B",
    "hex": "#E2D1D8"
  },
  {
    "name": "NCS S 1020-R30B",
    "hex": "#DFBBC9"
  },
  {
    "name": "NCS S 1030-R30B",
    "hex": "#DFACC2"
  },
  {
    "name": "NCS S 1040-R30B",
    "hex": "#DD94B8"
  },
  {
    "name": "NCS S 1050-R30B",
    "hex": "#DD7EAD"
  },
  {
    "name": "NCS S 1060-R30B",
    "hex": "#D95E9E"
  },
  {
    "name": "NCS S 2005-R30B",
    "hex": "#C5BEC1"
  },
  {
    "name": "NCS S 2010-R30B",
    "hex": "#C3B3BB"
  },
  {
    "name": "NCS S 2020-R30B",
    "hex": "#C8A6B5"
  },
  {
    "name": "NCS S 2030-R30B",
    "hex": "#C992AA"
  },
  {
    "name": "NCS S 2040-R30B",
    "hex": "#C1799B"
  },
  {
    "name": "NCS S 2050-R30B",
    "hex": "#BD628E"
  },
  {
    "name": "NCS S 2060-R30B",
    "hex": "#B6447E"
  },
  {
    "name": "NCS S 3010-R30B",
    "hex": "#AC9AA3"
  },
  {
    "name": "NCS S 3020-R30B",
    "hex": "#A88A9A"
  },
  {
    "name": "NCS S 3030-R30B",
    "hex": "#AD7890"
  },
  {
    "name": "NCS S 3040-R30B",
    "hex": "#A76386"
  },
  {
    "name": "NCS S 3050-R30B",
    "hex": "#A14370"
  },
  {
    "name": "NCS S 3055-R30B",
    "hex": "#93235F"
  },
  {
    "name": "NCS S 4010-R30B",
    "hex": "#9A8891"
  },
  {
    "name": "NCS S 4020-R30B",
    "hex": "#977483"
  },
  {
    "name": "NCS S 4030-R30B",
    "hex": "#925F78"
  },
  {
    "name": "NCS S 4040-R30B",
    "hex": "#8A4366"
  },
  {
    "name": "NCS S 4050-R30B",
    "hex": "#7D1A4D"
  },
  {
    "name": "NCS S 5010-R30B",
    "hex": "#87737C"
  },
  {
    "name": "NCS S 5020-R30B",
    "hex": "#835F71"
  },
  {
    "name": "NCS S 5030-R30B",
    "hex": "#7A455F"
  },
  {
    "name": "NCS S 5040-R30B",
    "hex": "#6C1F44"
  },
  {
    "name": "NCS S 6010-R30B",
    "hex": "#705A65"
  },
  {
    "name": "NCS S 6020-R30B",
    "hex": "#674154"
  },
  {
    "name": "NCS S 6030-R30B",
    "hex": "#5A1D3B"
  },
  {
    "name": "NCS S 7010-R30B",
    "hex": "#57464F"
  },
  {
    "name": "NCS S 7020-R30B",
    "hex": "#451E33"
  },
  {
    "name": "NCS S 8010-R30B",
    "hex": "#2E1E2A"
  },
  {
    "name": "NCS S 0505-R40B",
    "hex": "#EBE5EA"
  },
  {
    "name": "NCS S 0507-R40B",
    "hex": "#EDE4EB"
  },
  {
    "name": "NCS S 0510-R40B",
    "hex": "#ECE1EA"
  },
  {
    "name": "NCS S 0515-R40B",
    "hex": "#ECD8E8"
  },
  {
    "name": "NCS S 0520-R40B",
    "hex": "#EBCDE1"
  },
  {
    "name": "NCS S 0530-R40B",
    "hex": "#E3BCDB"
  },
  {
    "name": "NCS S 0603-R40B",
    "hex": "#EAE5E8"
  },
  {
    "name": "NCS S 1005-R40B",
    "hex": "#E0D9DD"
  },
  {
    "name": "NCS S 1010-R40B",
    "hex": "#DCCFD9"
  },
  {
    "name": "NCS S 1015-R40B",
    "hex": "#DBC8D7"
  },
  {
    "name": "NCS S 1020-R40B",
    "hex": "#D8BED1"
  },
  {
    "name": "NCS S 1030-R40B",
    "hex": "#D8ADCD"
  },
  {
    "name": "NCS S 1040-R40B",
    "hex": "#D59ECA"
  },
  {
    "name": "NCS S 1050-R40B",
    "hex": "#CF84BE"
  },
  {
    "name": "NCS S 1510-R40B",
    "hex": "#CEC1CB"
  },
  {
    "name": "NCS S 1515-R40B",
    "hex": "#D0BDCC"
  },
  {
    "name": "NCS S 2005-R40B",
    "hex": "#C4BEC3"
  },
  {
    "name": "NCS S 2010-R40B",
    "hex": "#C3B7C2"
  },
  {
    "name": "NCS S 2020-R40B",
    "hex": "#C0A5BA"
  },
  {
    "name": "NCS S 2030-R40B",
    "hex": "#B990B1"
  },
  {
    "name": "NCS S 2040-R40B",
    "hex": "#B781AD"
  },
  {
    "name": "NCS S 2050-R40B",
    "hex": "#B0639F"
  },
  {
    "name": "NCS S 2060-R40B",
    "hex": "#A7498F"
  },
  {
    "name": "NCS S 3010-R40B",
    "hex": "#A99BA7"
  },
  {
    "name": "NCS S 3020-R40B",
    "hex": "#A58A9F"
  },
  {
    "name": "NCS S 3030-R40B",
    "hex": "#A27899"
  },
  {
    "name": "NCS S 3040-R40B",
    "hex": "#9E6290"
  },
  {
    "name": "NCS S 3050-R40B",
    "hex": "#91447E"
  },
  {
    "name": "NCS S 3055-R40B",
    "hex": "#862F6F"
  },
  {
    "name": "NCS S 4020-R40B",
    "hex": "#91758C"
  },
  {
    "name": "NCS S 4030-R40B",
    "hex": "#8C6182"
  },
  {
    "name": "NCS S 4040-R40B",
    "hex": "#824674"
  },
  {
    "name": "NCS S 4050-R40B",
    "hex": "#742861"
  },
  {
    "name": "NCS S 5020-R40B",
    "hex": "#7B5E75"
  },
  {
    "name": "NCS S 5030-R40B",
    "hex": "#6E4364"
  },
  {
    "name": "NCS S 5040-R40B",
    "hex": "#5D214D"
  },
  {
    "name": "NCS S 6020-R40B",
    "hex": "#60445B"
  },
  {
    "name": "NCS S 6030-R40B",
    "hex": "#512445"
  },
  {
    "name": "NCS S 7020-R40B",
    "hex": "#3E1E37"
  },
  {
    "name": "NCS S 0505-R50B",
    "hex": "#E9E5EA"
  },
  {
    "name": "NCS S 0510-R50B",
    "hex": "#EAE1EA"
  },
  {
    "name": "NCS S 0520-R50B",
    "hex": "#DECEE4"
  },
  {
    "name": "NCS S 0530-R50B",
    "hex": "#D7BCE1"
  },
  {
    "name": "NCS S 0804-R50B",
    "hex": "#E3E0E5"
  },
  {
    "name": "NCS S 0907-R50B",
    "hex": "#DEDAE3"
  },
  {
    "name": "NCS S 1005-R50B",
    "hex": "#DBD7DC"
  },
  {
    "name": "NCS S 1010-R50B",
    "hex": "#D8D0DB"
  },
  {
    "name": "NCS S 1020-R50B",
    "hex": "#D0C0D6"
  },
  {
    "name": "NCS S 1030-R50B",
    "hex": "#CCB2D2"
  },
  {
    "name": "NCS S 1040-R50B",
    "hex": "#C8A2D6"
  },
  {
    "name": "NCS S 2005-R50B",
    "hex": "#BFBCC2"
  },
  {
    "name": "NCS S 2010-R50B",
    "hex": "#C0B7C3"
  },
  {
    "name": "NCS S 2020-R50B",
    "hex": "#B8A7C1"
  },
  {
    "name": "NCS S 2030-R50B",
    "hex": "#B698BB"
  },
  {
    "name": "NCS S 2040-R50B",
    "hex": "#A982B5"
  },
  {
    "name": "NCS S 2050-R50B",
    "hex": "#A26DAF"
  },
  {
    "name": "NCS S 3005-R50B",
    "hex": "#A9A6AD"
  },
  {
    "name": "NCS S 3010-R50B",
    "hex": "#A79FAD"
  },
  {
    "name": "NCS S 3020-R50B",
    "hex": "#A392A9"
  },
  {
    "name": "NCS S 3030-R50B",
    "hex": "#9A7FA4"
  },
  {
    "name": "NCS S 3040-R50B",
    "hex": "#946A9B"
  },
  {
    "name": "NCS S 3050-R50B",
    "hex": "#894F92"
  },
  {
    "name": "NCS S 3055-R50B",
    "hex": "#834289"
  },
  {
    "name": "NCS S 4005-R50B",
    "hex": "#949197"
  },
  {
    "name": "NCS S 4010-R50B",
    "hex": "#948D98"
  },
  {
    "name": "NCS S 4020-R50B",
    "hex": "#907C94"
  },
  {
    "name": "NCS S 4030-R50B",
    "hex": "#85678C"
  },
  {
    "name": "NCS S 4040-R50B",
    "hex": "#754C7F"
  },
  {
    "name": "NCS S 4050-R50B",
    "hex": "#682B6B"
  },
  {
    "name": "NCS S 5005-R50B",
    "hex": "#827F85"
  },
  {
    "name": "NCS S 5010-R50B",
    "hex": "#7B7380"
  },
  {
    "name": "NCS S 5020-R50B",
    "hex": "#75647E"
  },
  {
    "name": "NCS S 5030-R50B",
    "hex": "#6A4B72"
  },
  {
    "name": "NCS S 5040-R50B",
    "hex": "#57295B"
  },
  {
    "name": "NCS S 6005-R50B",
    "hex": "#6F6A73"
  },
  {
    "name": "NCS S 6010-R50B",
    "hex": "#6A5F6E"
  },
  {
    "name": "NCS S 6020-R50B",
    "hex": "#5B465E"
  },
  {
    "name": "NCS S 6030-R50B",
    "hex": "#4A274E"
  },
  {
    "name": "NCS S 7005-R50B",
    "hex": "#57525A"
  },
  {
    "name": "NCS S 7010-R50B",
    "hex": "#514A58"
  },
  {
    "name": "NCS S 7020-R50B",
    "hex": "#3C2641"
  },
  {
    "name": "NCS S 8005-R50B",
    "hex": "#302C36"
  },
  {
    "name": "NCS S 8010-R50B",
    "hex": "#2C2132"
  },
  {
    "name": "NCS S 0505-R60B",
    "hex": "#E9E9EF"
  },
  {
    "name": "NCS S 0507-R60B",
    "hex": "#E8E5EE"
  },
  {
    "name": "NCS S 0510-R60B",
    "hex": "#E1E0EA"
  },
  {
    "name": "NCS S 0515-R60B",
    "hex": "#DBDAEC"
  },
  {
    "name": "NCS S 0520-R60B",
    "hex": "#D3D1E8"
  },
  {
    "name": "NCS S 0525-R60B",
    "hex": "#CCC7E7"
  },
  {
    "name": "NCS S 0603-R60B",
    "hex": "#E7E6EA"
  },
  {
    "name": "NCS S 1005-R60B",
    "hex": "#D8D8DE"
  },
  {
    "name": "NCS S 1010-R60B",
    "hex": "#D3D2DC"
  },
  {
    "name": "NCS S 1015-R60B",
    "hex": "#CFCBDE"
  },
  {
    "name": "NCS S 1020-R60B",
    "hex": "#C9C5DE"
  },
  {
    "name": "NCS S 1030-R60B",
    "hex": "#BCB6DD"
  },
  {
    "name": "NCS S 1040-R60B",
    "hex": "#B4A5DC"
  },
  {
    "name": "NCS S 1510-R60B",
    "hex": "#C8C7D3"
  },
  {
    "name": "NCS S 1515-R60B",
    "hex": "#C3C0D5"
  },
  {
    "name": "NCS S 2005-R60B",
    "hex": "#BFBFC5"
  },
  {
    "name": "NCS S 2010-R60B",
    "hex": "#BAB9C5"
  },
  {
    "name": "NCS S 2020-R60B",
    "hex": "#ACAAC6"
  },
  {
    "name": "NCS S 2030-R60B",
    "hex": "#A59DC4"
  },
  {
    "name": "NCS S 2040-R60B",
    "hex": "#998BC0"
  },
  {
    "name": "NCS S 2050-R60B",
    "hex": "#8873B8"
  },
  {
    "name": "NCS S 3010-R60B",
    "hex": "#A1A1AE"
  },
  {
    "name": "NCS S 3020-R60B",
    "hex": "#9792AC"
  },
  {
    "name": "NCS S 3030-R60B",
    "hex": "#8983AC"
  },
  {
    "name": "NCS S 3040-R60B",
    "hex": "#7C6BA3"
  },
  {
    "name": "NCS S 3050-R60B",
    "hex": "#6D579E"
  },
  {
    "name": "NCS S 3555-R60B",
    "hex": "#4F337D"
  },
  {
    "name": "NCS S 4020-R60B",
    "hex": "#7F7B96"
  },
  {
    "name": "NCS S 4030-R60B",
    "hex": "#706791"
  },
  {
    "name": "NCS S 4040-R60B",
    "hex": "#634F86"
  },
  {
    "name": "NCS S 4050-R60B",
    "hex": "#4A357D"
  },
  {
    "name": "NCS S 5020-R60B",
    "hex": "#66617F"
  },
  {
    "name": "NCS S 5030-R60B",
    "hex": "#564C76"
  },
  {
    "name": "NCS S 5040-R60B",
    "hex": "#46306A"
  },
  {
    "name": "NCS S 6020-R60B",
    "hex": "#4D4765"
  },
  {
    "name": "NCS S 6030-R60B",
    "hex": "#372E59"
  },
  {
    "name": "NCS S 7020-R60B",
    "hex": "#2D2446"
  },
  {
    "name": "NCS S 0505-R70B",
    "hex": "#E4E7EC"
  },
  {
    "name": "NCS S 0510-R70B",
    "hex": "#DADEE9"
  },
  {
    "name": "NCS S 0520-R70B",
    "hex": "#CBD3EB"
  },
  {
    "name": "NCS S 0525-R70B",
    "hex": "#C3CDEB"
  },
  {
    "name": "NCS S 0804-R70B",
    "hex": "#DFE1E7"
  },
  {
    "name": "NCS S 0907-R70B",
    "hex": "#D8DBE5"
  },
  {
    "name": "NCS S 1005-R70B",
    "hex": "#D9DBE1"
  },
  {
    "name": "NCS S 1010-R70B",
    "hex": "#CFD3DE"
  },
  {
    "name": "NCS S 1020-R70B",
    "hex": "#BBC6DF"
  },
  {
    "name": "NCS S 1030-R70B",
    "hex": "#ADBADF"
  },
  {
    "name": "NCS S 1040-R70B",
    "hex": "#9DA8DE"
  },
  {
    "name": "NCS S 1550-R70B",
    "hex": "#7F90D2"
  },
  {
    "name": "NCS S 1555-R70B",
    "hex": "#7183CB"
  },
  {
    "name": "NCS S 2005-R70B",
    "hex": "#BDC0C7"
  },
  {
    "name": "NCS S 2010-R70B",
    "hex": "#B5BAC9"
  },
  {
    "name": "NCS S 2020-R70B",
    "hex": "#A4ADC6"
  },
  {
    "name": "NCS S 2030-R70B",
    "hex": "#939FC5"
  },
  {
    "name": "NCS S 2040-R70B",
    "hex": "#8491C7"
  },
  {
    "name": "NCS S 2050-R70B",
    "hex": "#6E7EC0"
  },
  {
    "name": "NCS S 2060-R70B",
    "hex": "#5F69BD"
  },
  {
    "name": "NCS S 3010-R70B",
    "hex": "#A0A5B1"
  },
  {
    "name": "NCS S 3020-R70B",
    "hex": "#8D95AD"
  },
  {
    "name": "NCS S 3030-R70B",
    "hex": "#7D87AE"
  },
  {
    "name": "NCS S 3040-R70B",
    "hex": "#6877AD"
  },
  {
    "name": "NCS S 3050-R70B",
    "hex": "#5361A7"
  },
  {
    "name": "NCS S 3060-R70B",
    "hex": "#3D499D"
  },
  {
    "name": "NCS S 4010-R70B",
    "hex": "#888D99"
  },
  {
    "name": "NCS S 4020-R70B",
    "hex": "#767D99"
  },
  {
    "name": "NCS S 4030-R70B",
    "hex": "#647099"
  },
  {
    "name": "NCS S 4040-R70B",
    "hex": "#4E5B94"
  },
  {
    "name": "NCS S 4050-R70B",
    "hex": "#374186"
  },
  {
    "name": "NCS S 4055-R70B",
    "hex": "#222D7B"
  },
  {
    "name": "NCS S 4550-R70B",
    "hex": "#242C71"
  },
  {
    "name": "NCS S 5010-R70B",
    "hex": "#757886"
  },
  {
    "name": "NCS S 5020-R70B",
    "hex": "#646984"
  },
  {
    "name": "NCS S 5030-R70B",
    "hex": "#4E5781"
  },
  {
    "name": "NCS S 5040-R70B",
    "hex": "#2F3770"
  },
  {
    "name": "NCS S 5540-R70B",
    "hex": "#1B2762"
  },
  {
    "name": "NCS S 6010-R70B",
    "hex": "#5F6573"
  },
  {
    "name": "NCS S 6020-R70B",
    "hex": "#464C6B"
  },
  {
    "name": "NCS S 6030-R70B",
    "hex": "#232D5C"
  },
  {
    "name": "NCS S 7010-R70B",
    "hex": "#454859"
  },
  {
    "name": "NCS S 7020-R70B",
    "hex": "#262F4E"
  },
  {
    "name": "NCS S 8010-R70B",
    "hex": "#23293A"
  },
  {
    "name": "NCS S 0505-R80B",
    "hex": "#E2E7EC"
  },
  {
    "name": "NCS S 0507-R80B",
    "hex": "#DCE5ED"
  },
  {
    "name": "NCS S 0510-R80B",
    "hex": "#D9E2EC"
  },
  {
    "name": "NCS S 0515-R80B",
    "hex": "#CBDBEB"
  },
  {
    "name": "NCS S 0520-R80B",
    "hex": "#C1D6EB"
  },
  {
    "name": "NCS S 0530-R80B",
    "hex": "#ABC9EA"
  },
  {
    "name": "NCS S 0603-R80B",
    "hex": "#E3E7EA"
  },
  {
    "name": "NCS S 1005-R80B",
    "hex": "#D4D9E0"
  },
  {
    "name": "NCS S 1010-R80B",
    "hex": "#C9D5DE"
  },
  {
    "name": "NCS S 1015-R80B",
    "hex": "#C0D0E0"
  },
  {
    "name": "NCS S 1020-R80B",
    "hex": "#B4C8DB"
  },
  {
    "name": "NCS S 1030-R80B",
    "hex": "#A3BDE1"
  },
  {
    "name": "NCS S 1040-R80B",
    "hex": "#8CB0DF"
  },
  {
    "name": "NCS S 1510-R80B",
    "hex": "#BCC6D2"
  },
  {
    "name": "NCS S 1515-R80B",
    "hex": "#B1C2D4"
  },
  {
    "name": "NCS S 1550-R80B",
    "hex": "#6097D5"
  },
  {
    "name": "NCS S 1555-R80B",
    "hex": "#5289CC"
  },
  {
    "name": "NCS S 2005-R80B",
    "hex": "#BEC3C8"
  },
  {
    "name": "NCS S 2010-R80B",
    "hex": "#AEB9C6"
  },
  {
    "name": "NCS S 2020-R80B",
    "hex": "#9BAFC8"
  },
  {
    "name": "NCS S 2030-R80B",
    "hex": "#8AA1C6"
  },
  {
    "name": "NCS S 2040-R80B",
    "hex": "#7295C5"
  },
  {
    "name": "NCS S 2050-R80B",
    "hex": "#5683C3"
  },
  {
    "name": "NCS S 2060-R80B",
    "hex": "#3674C1"
  },
  {
    "name": "NCS S 2565-R80B",
    "hex": "#0055AA"
  },
  {
    "name": "NCS S 3005-R80B",
    "hex": "#A3ABB1"
  },
  {
    "name": "NCS S 3010-R80B",
    "hex": "#96A1AD"
  },
  {
    "name": "NCS S 3020-R80B",
    "hex": "#8696AF"
  },
  {
    "name": "NCS S 3030-R80B",
    "hex": "#6D88AB"
  },
  {
    "name": "NCS S 3040-R80B",
    "hex": "#5678AC"
  },
  {
    "name": "NCS S 3050-R80B",
    "hex": "#3564A4"
  },
  {
    "name": "NCS S 3060-R80B",
    "hex": "#004E9B"
  },
  {
    "name": "NCS S 3560-R80B",
    "hex": "#00408B"
  },
  {
    "name": "NCS S 4005-R80B",
    "hex": "#8D939B"
  },
  {
    "name": "NCS S 4020-R80B",
    "hex": "#6E7F99"
  },
  {
    "name": "NCS S 4030-R80B",
    "hex": "#557198"
  },
  {
    "name": "NCS S 4040-R80B",
    "hex": "#446194"
  },
  {
    "name": "NCS S 4050-R80B",
    "hex": "#004584"
  },
  {
    "name": "NCS S 4550-R80B",
    "hex": "#003272"
  },
  {
    "name": "NCS S 5005-R80B",
    "hex": "#797E84"
  },
  {
    "name": "NCS S 5020-R80B",
    "hex": "#576983"
  },
  {
    "name": "NCS S 5030-R80B",
    "hex": "#3B567D"
  },
  {
    "name": "NCS S 5040-R80B",
    "hex": "#104175"
  },
  {
    "name": "NCS S 6005-R80B",
    "hex": "#62686F"
  },
  {
    "name": "NCS S 6020-R80B",
    "hex": "#394C6A"
  },
  {
    "name": "NCS S 6030-R80B",
    "hex": "#16355F"
  },
  {
    "name": "NCS S 7005-R80B",
    "hex": "#4F555C"
  },
  {
    "name": "NCS S 7020-R80B",
    "hex": "#1B314E"
  },
  {
    "name": "NCS S 8005-R80B",
    "hex": "#31373F"
  },
  {
    "name": "NCS S 8505-R80B",
    "hex": "#1A2027"
  },
  {
    "name": "NCS S 0505-R90B",
    "hex": "#E0E8EC"
  },
  {
    "name": "NCS S 0510-R90B",
    "hex": "#D6E6F1"
  },
  {
    "name": "NCS S 0515-R90B",
    "hex": "#C7DCEB"
  },
  {
    "name": "NCS S 0520-R90B",
    "hex": "#BBD8E9"
  },
  {
    "name": "NCS S 0530-R90B",
    "hex": "#A0CCE8"
  },
  {
    "name": "NCS S 0540-R90B",
    "hex": "#86BFE9"
  },
  {
    "name": "NCS S 0804-R90B",
    "hex": "#DDE2E5"
  },
  {
    "name": "NCS S 0907-R90B",
    "hex": "#D4DDE5"
  },
  {
    "name": "NCS S 1005-R90B",
    "hex": "#D2DADE"
  },
  {
    "name": "NCS S 1010-R90B",
    "hex": "#C3D3DD"
  },
  {
    "name": "NCS S 1015-R90B",
    "hex": "#BCD1E0"
  },
  {
    "name": "NCS S 1020-R90B",
    "hex": "#AFCCE0"
  },
  {
    "name": "NCS S 1030-R90B",
    "hex": "#97BDDA"
  },
  {
    "name": "NCS S 1040-R90B",
    "hex": "#7CB1D9"
  },
  {
    "name": "NCS S 1050-R90B",
    "hex": "#58A8DF"
  },
  {
    "name": "NCS S 1510-R90B",
    "hex": "#BAC7D2"
  },
  {
    "name": "NCS S 1515-R90B",
    "hex": "#AEC3D2"
  },
  {
    "name": "NCS S 1560-R90B",
    "hex": "#008ACA"
  },
  {
    "name": "NCS S 2005-R90B",
    "hex": "#B9C1C7"
  },
  {
    "name": "NCS S 2010-R90B",
    "hex": "#B1BFC8"
  },
  {
    "name": "NCS S 2020-R90B",
    "hex": "#96B1C6"
  },
  {
    "name": "NCS S 2030-R90B",
    "hex": "#7EA5C3"
  },
  {
    "name": "NCS S 2040-R90B",
    "hex": "#689BC4"
  },
  {
    "name": "NCS S 2050-R90B",
    "hex": "#368BC2"
  },
  {
    "name": "NCS S 2060-R90B",
    "hex": "#0079BD"
  },
  {
    "name": "NCS S 2065-R90B",
    "hex": "#006FBB"
  },
  {
    "name": "NCS S 3010-R90B",
    "hex": "#94A4B0"
  },
  {
    "name": "NCS S 3020-R90B",
    "hex": "#7F98AF"
  },
  {
    "name": "NCS S 3030-R90B",
    "hex": "#698FB0"
  },
  {
    "name": "NCS S 3040-R90B",
    "hex": "#4A81AC"
  },
  {
    "name": "NCS S 3050-R90B",
    "hex": "#2070A7"
  },
  {
    "name": "NCS S 3060-R90B",
    "hex": "#005D9F"
  },
  {
    "name": "NCS S 3065-R90B",
    "hex": "#004E99"
  },
  {
    "name": "NCS S 3560-R90B",
    "hex": "#00498D"
  },
  {
    "name": "NCS S 4010-R90B",
    "hex": "#828F9B"
  },
  {
    "name": "NCS S 4020-R90B",
    "hex": "#6B839A"
  },
  {
    "name": "NCS S 4030-R90B",
    "hex": "#527898"
  },
  {
    "name": "NCS S 4040-R90B",
    "hex": "#2F6591"
  },
  {
    "name": "NCS S 4050-R90B",
    "hex": "#005389"
  },
  {
    "name": "NCS S 4550-R90B",
    "hex": "#004076"
  },
  {
    "name": "NCS S 5010-R90B",
    "hex": "#6D7A86"
  },
  {
    "name": "NCS S 5020-R90B",
    "hex": "#556D82"
  },
  {
    "name": "NCS S 5030-R90B",
    "hex": "#375D7E"
  },
  {
    "name": "NCS S 5040-R90B",
    "hex": "#004673"
  },
  {
    "name": "NCS S 5540-R90B",
    "hex": "#003663"
  },
  {
    "name": "NCS S 6010-R90B",
    "hex": "#57646F"
  },
  {
    "name": "NCS S 6020-R90B",
    "hex": "#38526A"
  },
  {
    "name": "NCS S 6030-R90B",
    "hex": "#0C3F5F"
  },
  {
    "name": "NCS S 7010-R90B",
    "hex": "#3F4C58"
  },
  {
    "name": "NCS S 7020-R90B",
    "hex": "#11334A"
  },
  {
    "name": "NCS S 8010-R90B",
    "hex": "#1E2D3B"
  },
  {
    "name": "NCS S 0505-B",
    "hex": "#DEE8EC"
  },
  {
    "name": "NCS S 0507-B",
    "hex": "#DCE9EE"
  },
  {
    "name": "NCS S 0510-B",
    "hex": "#D0E1E9"
  },
  {
    "name": "NCS S 0515-B",
    "hex": "#C5E0EA"
  },
  {
    "name": "NCS S 0520-B",
    "hex": "#BBDFED"
  },
  {
    "name": "NCS S 0530-B",
    "hex": "#9BD4EA"
  },
  {
    "name": "NCS S 0540-B",
    "hex": "#7BC5E0"
  },
  {
    "name": "NCS S 1005-B",
    "hex": "#D3DDE1"
  },
  {
    "name": "NCS S 1010-B",
    "hex": "#C0D4DB"
  },
  {
    "name": "NCS S 1015-B",
    "hex": "#B6D2DE"
  },
  {
    "name": "NCS S 1020-B",
    "hex": "#AACEDC"
  },
  {
    "name": "NCS S 1030-B",
    "hex": "#8DC3D9"
  },
  {
    "name": "NCS S 1040-B",
    "hex": "#6AB8D6"
  },
  {
    "name": "NCS S 1050-B",
    "hex": "#43ACD2"
  },
  {
    "name": "NCS S 1060-B",
    "hex": "#00A1D6"
  },
  {
    "name": "NCS S 1510-B",
    "hex": "#B7C8D0"
  },
  {
    "name": "NCS S 1515-B",
    "hex": "#ABC4D0"
  },
  {
    "name": "NCS S 1565-B",
    "hex": "#0087BE"
  },
  {
    "name": "NCS S 2005-B",
    "hex": "#B8C1C5"
  },
  {
    "name": "NCS S 2010-B",
    "hex": "#A9BAC2"
  },
  {
    "name": "NCS S 2020-B",
    "hex": "#90B5C6"
  },
  {
    "name": "NCS S 2030-B",
    "hex": "#79ACC4"
  },
  {
    "name": "NCS S 2040-B",
    "hex": "#589EBF"
  },
  {
    "name": "NCS S 2050-B",
    "hex": "#1E94BD"
  },
  {
    "name": "NCS S 2060-B",
    "hex": "#0086BC"
  },
  {
    "name": "NCS S 2065-B",
    "hex": "#0077AE"
  },
  {
    "name": "NCS S 3010-B",
    "hex": "#93A5AE"
  },
  {
    "name": "NCS S 3020-B",
    "hex": "#7C9AAA"
  },
  {
    "name": "NCS S 3030-B",
    "hex": "#608EA8"
  },
  {
    "name": "NCS S 3040-B",
    "hex": "#3385A7"
  },
  {
    "name": "NCS S 3050-B",
    "hex": "#0077A1"
  },
  {
    "name": "NCS S 3060-B",
    "hex": "#006699"
  },
  {
    "name": "NCS S 4020-B",
    "hex": "#618393"
  },
  {
    "name": "NCS S 4030-B",
    "hex": "#467891"
  },
  {
    "name": "NCS S 4040-B",
    "hex": "#066B8D"
  },
  {
    "name": "NCS S 4050-B",
    "hex": "#006089"
  },
  {
    "name": "NCS S 4055-B",
    "hex": "#005483"
  },
  {
    "name": "NCS S 4550-B",
    "hex": "#004873"
  },
  {
    "name": "NCS S 5020-B",
    "hex": "#4C6C7E"
  },
  {
    "name": "NCS S 5030-B",
    "hex": "#2C627B"
  },
  {
    "name": "NCS S 5040-B",
    "hex": "#005071"
  },
  {
    "name": "NCS S 5540-B",
    "hex": "#004062"
  },
  {
    "name": "NCS S 6020-B",
    "hex": "#375667"
  },
  {
    "name": "NCS S 6030-B",
    "hex": "#084860"
  },
  {
    "name": "NCS S 7020-B",
    "hex": "#113649"
  },
  {
    "name": "NCS S 0510-B10G",
    "hex": "#CFE5EA"
  },
  {
    "name": "NCS S 0520-B10G",
    "hex": "#B2DEE8"
  },
  {
    "name": "NCS S 0530-B10G",
    "hex": "#93D3E3"
  },
  {
    "name": "NCS S 0540-B10G",
    "hex": "#71CBDF"
  },
  {
    "name": "NCS S 1010-B10G",
    "hex": "#C4D7DA"
  },
  {
    "name": "NCS S 1020-B10G",
    "hex": "#9FCDD7"
  },
  {
    "name": "NCS S 1030-B10G",
    "hex": "#82C5D5"
  },
  {
    "name": "NCS S 1040-B10G",
    "hex": "#61BDD3"
  },
  {
    "name": "NCS S 1050-B10G",
    "hex": "#22B2D1"
  },
  {
    "name": "NCS S 1555-B10G",
    "hex": "#00A0C2"
  },
  {
    "name": "NCS S 2010-B10G",
    "hex": "#ABBABE"
  },
  {
    "name": "NCS S 2020-B10G",
    "hex": "#8BB4C0"
  },
  {
    "name": "NCS S 2030-B10G",
    "hex": "#72AEBF"
  },
  {
    "name": "NCS S 2040-B10G",
    "hex": "#4CA0B9"
  },
  {
    "name": "NCS S 2050-B10G",
    "hex": "#0097B6"
  },
  {
    "name": "NCS S 2055-B10G",
    "hex": "#0090B1"
  },
  {
    "name": "NCS S 3010-B10G",
    "hex": "#93A5AB"
  },
  {
    "name": "NCS S 3020-B10G",
    "hex": "#769EAA"
  },
  {
    "name": "NCS S 3030-B10G",
    "hex": "#5996A8"
  },
  {
    "name": "NCS S 3040-B10G",
    "hex": "#2C8CA5"
  },
  {
    "name": "NCS S 3050-B10G",
    "hex": "#007E9E"
  },
  {
    "name": "NCS S 3060-B10G",
    "hex": "#006F94"
  },
  {
    "name": "NCS S 4010-B10G",
    "hex": "#7D9097"
  },
  {
    "name": "NCS S 4020-B10G",
    "hex": "#628995"
  },
  {
    "name": "NCS S 4030-B10G",
    "hex": "#3C7D90"
  },
  {
    "name": "NCS S 4040-B10G",
    "hex": "#006D84"
  },
  {
    "name": "NCS S 4050-B10G",
    "hex": "#006381"
  },
  {
    "name": "NCS S 5010-B10G",
    "hex": "#697C82"
  },
  {
    "name": "NCS S 5020-B10G",
    "hex": "#4C7280"
  },
  {
    "name": "NCS S 5030-B10G",
    "hex": "#2A6579"
  },
  {
    "name": "NCS S 5040-B10G",
    "hex": "#00546D"
  },
  {
    "name": "NCS S 5045-B10G",
    "hex": "#004965"
  },
  {
    "name": "NCS S 5540-B10G",
    "hex": "#00465E"
  },
  {
    "name": "NCS S 6010-B10G",
    "hex": "#56686E"
  },
  {
    "name": "NCS S 6020-B10G",
    "hex": "#2F5864"
  },
  {
    "name": "NCS S 6030-B10G",
    "hex": "#004B5F"
  },
  {
    "name": "NCS S 7010-B10G",
    "hex": "#3D5058"
  },
  {
    "name": "NCS S 7020-B10G",
    "hex": "#143E4C"
  },
  {
    "name": "NCS S 8010-B10G",
    "hex": "#1E3037"
  },
  {
    "name": "NCS S 0505-B20G",
    "hex": "#DFECEF"
  },
  {
    "name": "NCS S 0507-B20G",
    "hex": "#DAEAEC"
  },
  {
    "name": "NCS S 0515-B20G",
    "hex": "#C0E2E6"
  },
  {
    "name": "NCS S 0907-B20G",
    "hex": "#CFDEE1"
  },
  {
    "name": "NCS S 1005-B20G",
    "hex": "#CDDCDC"
  },
  {
    "name": "NCS S 1015-B20G",
    "hex": "#B2D4D8"
  },
  {
    "name": "NCS S 1040-B20G",
    "hex": "#68C3D3"
  },
  {
    "name": "NCS S 1050-B20G",
    "hex": "#0BB6CB"
  },
  {
    "name": "NCS S 1510-B20G",
    "hex": "#B7CCCF"
  },
  {
    "name": "NCS S 1515-B20G",
    "hex": "#A9C8CD"
  },
  {
    "name": "NCS S 2005-B20G",
    "hex": "#B6C2C3"
  },
  {
    "name": "NCS S 2040-B20G",
    "hex": "#47A8B7"
  },
  {
    "name": "NCS S 2050-B20G",
    "hex": "#009AB0"
  },
  {
    "name": "NCS S 2555-B20G",
    "hex": "#0089A2"
  },
  {
    "name": "NCS S 3005-B20G",
    "hex": "#9DAAAC"
  },
  {
    "name": "NCS S 3040-B20G",
    "hex": "#218D9E"
  },
  {
    "name": "NCS S 3050-B20G",
    "hex": "#008396"
  },
  {
    "name": "NCS S 3060-B20G",
    "hex": "#00718B"
  },
  {
    "name": "NCS S 4005-B20G",
    "hex": "#869295"
  },
  {
    "name": "NCS S 4040-B20G",
    "hex": "#007687"
  },
  {
    "name": "NCS S 4050-B20G",
    "hex": "#00697C"
  },
  {
    "name": "NCS S 4550-B20G",
    "hex": "#00556A"
  },
  {
    "name": "NCS S 5005-B20G",
    "hex": "#778285"
  },
  {
    "name": "NCS S 5040-B20G",
    "hex": "#005A6B"
  },
  {
    "name": "NCS S 5540-B20G",
    "hex": "#00485B"
  },
  {
    "name": "NCS S 6005-B20G",
    "hex": "#606C6E"
  },
  {
    "name": "NCS S 7005-B20G",
    "hex": "#4B5658"
  },
  {
    "name": "NCS S 8005-B20G",
    "hex": "#2E383A"
  },
  {
    "name": "NCS S 8505-B20G",
    "hex": "#192325"
  },
  {
    "name": "NCS S 0510-B30G",
    "hex": "#CEE6E6"
  },
  {
    "name": "NCS S 0520-B30G",
    "hex": "#B0DFE2"
  },
  {
    "name": "NCS S 0530-B30G",
    "hex": "#8FD7DE"
  },
  {
    "name": "NCS S 0540-B30G",
    "hex": "#6CCFD6"
  },
  {
    "name": "NCS S 1010-B30G",
    "hex": "#C2DBDD"
  },
  {
    "name": "NCS S 1020-B30G",
    "hex": "#A2D1D4"
  },
  {
    "name": "NCS S 1030-B30G",
    "hex": "#82C9D0"
  },
  {
    "name": "NCS S 1040-B30G",
    "hex": "#60C1CA"
  },
  {
    "name": "NCS S 1050-B30G",
    "hex": "#0EBAC8"
  },
  {
    "name": "NCS S 2010-B30G",
    "hex": "#A7BFC1"
  },
  {
    "name": "NCS S 2020-B30G",
    "hex": "#8FBDC3"
  },
  {
    "name": "NCS S 2030-B30G",
    "hex": "#69ADB5"
  },
  {
    "name": "NCS S 2040-B30G",
    "hex": "#41A6AF"
  },
  {
    "name": "NCS S 2050-B30G",
    "hex": "#00A0AE"
  },
  {
    "name": "NCS S 2555-B30G",
    "hex": "#00909F"
  },
  {
    "name": "NCS S 3010-B30G",
    "hex": "#91A9AD"
  },
  {
    "name": "NCS S 3020-B30G",
    "hex": "#79A4AA"
  },
  {
    "name": "NCS S 3030-B30G",
    "hex": "#5C9AA2"
  },
  {
    "name": "NCS S 3040-B30G",
    "hex": "#22919C"
  },
  {
    "name": "NCS S 3050-B30G",
    "hex": "#008391"
  },
  {
    "name": "NCS S 3060-B30G",
    "hex": "#00798B"
  },
  {
    "name": "NCS S 4010-B30G",
    "hex": "#7D9194"
  },
  {
    "name": "NCS S 4020-B30G",
    "hex": "#5D888D"
  },
  {
    "name": "NCS S 4030-B30G",
    "hex": "#42838A"
  },
  {
    "name": "NCS S 4040-B30G",
    "hex": "#007782"
  },
  {
    "name": "NCS S 4050-B30G",
    "hex": "#006C7A"
  },
  {
    "name": "NCS S 4550-B30G",
    "hex": "#005B68"
  },
  {
    "name": "NCS S 5010-B30G",
    "hex": "#697C7F"
  },
  {
    "name": "NCS S 5020-B30G",
    "hex": "#4C767B"
  },
  {
    "name": "NCS S 5030-B30G",
    "hex": "#256770"
  },
  {
    "name": "NCS S 5040-B30G",
    "hex": "#005B66"
  },
  {
    "name": "NCS S 5540-B30G",
    "hex": "#004A55"
  },
  {
    "name": "NCS S 6010-B30G",
    "hex": "#55686B"
  },
  {
    "name": "NCS S 6020-B30G",
    "hex": "#325D64"
  },
  {
    "name": "NCS S 6030-B30G",
    "hex": "#004F58"
  },
  {
    "name": "NCS S 6530-B30G",
    "hex": "#004048"
  },
  {
    "name": "NCS S 7010-B30G",
    "hex": "#3E5053"
  },
  {
    "name": "NCS S 7020-B30G",
    "hex": "#113F45"
  },
  {
    "name": "NCS S 8010-B30G",
    "hex": "#1C3437"
  },
  {
    "name": "NCS S 0520-B40G",
    "hex": "#B4E1E3"
  },
  {
    "name": "NCS S 0530-B40G",
    "hex": "#93DADB"
  },
  {
    "name": "NCS S 1020-B40G",
    "hex": "#A6D3D5"
  },
  {
    "name": "NCS S 1030-B40G",
    "hex": "#84CCCF"
  },
  {
    "name": "NCS S 1040-B40G",
    "hex": "#58C2C7"
  },
  {
    "name": "NCS S 1050-B40G",
    "hex": "#05BEC4"
  },
  {
    "name": "NCS S 2020-B40G",
    "hex": "#8EBABC"
  },
  {
    "name": "NCS S 2030-B40G",
    "hex": "#69B1B4"
  },
  {
    "name": "NCS S 2040-B40G",
    "hex": "#47ACB1"
  },
  {
    "name": "NCS S 2050-B40G",
    "hex": "#00A2A9"
  },
  {
    "name": "NCS S 2555-B40G",
    "hex": "#008E93"
  },
  {
    "name": "NCS S 3020-B40G",
    "hex": "#76A2A4"
  },
  {
    "name": "NCS S 3030-B40G",
    "hex": "#539B9E"
  },
  {
    "name": "NCS S 3040-B40G",
    "hex": "#1F9196"
  },
  {
    "name": "NCS S 3050-B40G",
    "hex": "#00878E"
  },
  {
    "name": "NCS S 3060-B40G",
    "hex": "#007D85"
  },
  {
    "name": "NCS S 4040-B40G",
    "hex": "#007A7F"
  },
  {
    "name": "NCS S 4050-B40G",
    "hex": "#006A71"
  },
  {
    "name": "NCS S 4055-B40G",
    "hex": "#006268"
  },
  {
    "name": "NCS S 4550-B40G",
    "hex": "#005E64"
  },
  {
    "name": "NCS S 5040-B40G",
    "hex": "#005C61"
  },
  {
    "name": "NCS S 5540-B40G",
    "hex": "#004B51"
  },
  {
    "name": "NCS S 0505-B50G",
    "hex": "#E1ECEB"
  },
  {
    "name": "NCS S 0510-B50G",
    "hex": "#D7EBEA"
  },
  {
    "name": "NCS S 0515-B50G",
    "hex": "#C5E8E6"
  },
  {
    "name": "NCS S 0520-B50G",
    "hex": "#B8E4E2"
  },
  {
    "name": "NCS S 0530-B50G",
    "hex": "#97E0DF"
  },
  {
    "name": "NCS S 0804-B50G",
    "hex": "#DDE6E5"
  },
  {
    "name": "NCS S 1005-B50G",
    "hex": "#D2DEDD"
  },
  {
    "name": "NCS S 1010-B50G",
    "hex": "#C4DAD9"
  },
  {
    "name": "NCS S 1015-B50G",
    "hex": "#B5D7D5"
  },
  {
    "name": "NCS S 1020-B50G",
    "hex": "#A6D4D1"
  },
  {
    "name": "NCS S 1030-B50G",
    "hex": "#87CCCA"
  },
  {
    "name": "NCS S 1040-B50G",
    "hex": "#5CC5C4"
  },
  {
    "name": "NCS S 1050-B50G",
    "hex": "#05BEBC"
  },
  {
    "name": "NCS S 1510-B50G",
    "hex": "#B6CCCB"
  },
  {
    "name": "NCS S 1515-B50G",
    "hex": "#A7C9C7"
  },
  {
    "name": "NCS S 2005-B50G",
    "hex": "#B7C2C1"
  },
  {
    "name": "NCS S 2010-B50G",
    "hex": "#A9BFBD"
  },
  {
    "name": "NCS S 2020-B50G",
    "hex": "#8BB8B6"
  },
  {
    "name": "NCS S 2030-B50G",
    "hex": "#6EB4B3"
  },
  {
    "name": "NCS S 2040-B50G",
    "hex": "#49ACAC"
  },
  {
    "name": "NCS S 2050-B50G",
    "hex": "#009F9F"
  },
  {
    "name": "NCS S 2060-B50G",
    "hex": "#009697"
  },
  {
    "name": "NCS S 3010-B50G",
    "hex": "#90A6A7"
  },
  {
    "name": "NCS S 3020-B50G",
    "hex": "#7AA5A5"
  },
  {
    "name": "NCS S 3030-B50G",
    "hex": "#5B9E9E"
  },
  {
    "name": "NCS S 3040-B50G",
    "hex": "#289191"
  },
  {
    "name": "NCS S 3050-B50G",
    "hex": "#008787"
  },
  {
    "name": "NCS S 3055-B50G",
    "hex": "#007F80"
  },
  {
    "name": "NCS S 4010-B50G",
    "hex": "#819393"
  },
  {
    "name": "NCS S 4020-B50G",
    "hex": "#638D8D"
  },
  {
    "name": "NCS S 4030-B50G",
    "hex": "#378281"
  },
  {
    "name": "NCS S 4040-B50G",
    "hex": "#007A7A"
  },
  {
    "name": "NCS S 4050-B50G",
    "hex": "#006B6C"
  },
  {
    "name": "NCS S 4550-B50G",
    "hex": "#005A5B"
  },
  {
    "name": "NCS S 5010-B50G",
    "hex": "#6A7F80"
  },
  {
    "name": "NCS S 5020-B50G",
    "hex": "#4A7776"
  },
  {
    "name": "NCS S 5030-B50G",
    "hex": "#206D6D"
  },
  {
    "name": "NCS S 5040-B50G",
    "hex": "#005C5C"
  },
  {
    "name": "NCS S 5540-B50G",
    "hex": "#005051"
  },
  {
    "name": "NCS S 6010-B50G",
    "hex": "#546969"
  },
  {
    "name": "NCS S 6020-B50G",
    "hex": "#376060"
  },
  {
    "name": "NCS S 6030-B50G",
    "hex": "#004949"
  },
  {
    "name": "NCS S 6530-B50G",
    "hex": "#004040"
  },
  {
    "name": "NCS S 7010-B50G",
    "hex": "#3A5151"
  },
  {
    "name": "NCS S 7020-B50G",
    "hex": "#0F4242"
  },
  {
    "name": "NCS S 8010-B50G",
    "hex": "#203636"
  },
  {
    "name": "NCS S 0520-B60G",
    "hex": "#B4E5E0"
  },
  {
    "name": "NCS S 0530-B60G",
    "hex": "#97DED7"
  },
  {
    "name": "NCS S 1020-B60G",
    "hex": "#A9D6D2"
  },
  {
    "name": "NCS S 1030-B60G",
    "hex": "#89CFC9"
  },
  {
    "name": "NCS S 1040-B60G",
    "hex": "#60C9C1"
  },
  {
    "name": "NCS S 1050-B60G",
    "hex": "#05C2B9"
  },
  {
    "name": "NCS S 2020-B60G",
    "hex": "#8EBBB7"
  },
  {
    "name": "NCS S 2030-B60G",
    "hex": "#70B7B2"
  },
  {
    "name": "NCS S 2040-B60G",
    "hex": "#3FB0AA"
  },
  {
    "name": "NCS S 2050-B60G",
    "hex": "#00A29C"
  },
  {
    "name": "NCS S 2555-B60G",
    "hex": "#00928B"
  },
  {
    "name": "NCS S 3020-B60G",
    "hex": "#77A39F"
  },
  {
    "name": "NCS S 3030-B60G",
    "hex": "#529C97"
  },
  {
    "name": "NCS S 3040-B60G",
    "hex": "#1F9590"
  },
  {
    "name": "NCS S 3050-B60G",
    "hex": "#008882"
  },
  {
    "name": "NCS S 3555-B60G",
    "hex": "#007570"
  },
  {
    "name": "NCS S 4040-B60G",
    "hex": "#007874"
  },
  {
    "name": "NCS S 4050-B60G",
    "hex": "#006964"
  },
  {
    "name": "NCS S 5040-B60G",
    "hex": "#005A57"
  },
  {
    "name": "NCS S 6035-B60G",
    "hex": "#004643"
  },
  {
    "name": "NCS S 0510-B70G",
    "hex": "#D4ECE6"
  },
  {
    "name": "NCS S 0520-B70G",
    "hex": "#B4E6DC"
  },
  {
    "name": "NCS S 0530-B70G",
    "hex": "#9AE1D4"
  },
  {
    "name": "NCS S 1010-B70G",
    "hex": "#C5DAD7"
  },
  {
    "name": "NCS S 1020-B70G",
    "hex": "#A6D7CE"
  },
  {
    "name": "NCS S 1030-B70G",
    "hex": "#8ED2C8"
  },
  {
    "name": "NCS S 1040-B70G",
    "hex": "#60C9BD"
  },
  {
    "name": "NCS S 1050-B70G",
    "hex": "#04C5B7"
  },
  {
    "name": "NCS S 2010-B70G",
    "hex": "#A9BFBC"
  },
  {
    "name": "NCS S 2020-B70G",
    "hex": "#8ABCB5"
  },
  {
    "name": "NCS S 2030-B70G",
    "hex": "#6DB4AC"
  },
  {
    "name": "NCS S 2040-B70G",
    "hex": "#3EABA0"
  },
  {
    "name": "NCS S 2050-B70G",
    "hex": "#00A699"
  },
  {
    "name": "NCS S 2060-B70G",
    "hex": "#009C8E"
  },
  {
    "name": "NCS S 3010-B70G",
    "hex": "#94A9A6"
  },
  {
    "name": "NCS S 3020-B70G",
    "hex": "#75A39D"
  },
  {
    "name": "NCS S 3030-B70G",
    "hex": "#559C94"
  },
  {
    "name": "NCS S 3040-B70G",
    "hex": "#2B9589"
  },
  {
    "name": "NCS S 3050-B70G",
    "hex": "#00887B"
  },
  {
    "name": "NCS S 3060-B70G",
    "hex": "#00776B"
  },
  {
    "name": "NCS S 4010-B70G",
    "hex": "#7D9491"
  },
  {
    "name": "NCS S 4020-B70G",
    "hex": "#5C8C85"
  },
  {
    "name": "NCS S 4030-B70G",
    "hex": "#40877F"
  },
  {
    "name": "NCS S 4040-B70G",
    "hex": "#00786F"
  },
  {
    "name": "NCS S 4050-B70G",
    "hex": "#006C62"
  },
  {
    "name": "NCS S 5010-B70G",
    "hex": "#69807C"
  },
  {
    "name": "NCS S 5020-B70G",
    "hex": "#4A7771"
  },
  {
    "name": "NCS S 5030-B70G",
    "hex": "#1B6B64"
  },
  {
    "name": "NCS S 5040-B70G",
    "hex": "#005A52"
  },
  {
    "name": "NCS S 6010-B70G",
    "hex": "#4F6763"
  },
  {
    "name": "NCS S 6020-B70G",
    "hex": "#35605B"
  },
  {
    "name": "NCS S 6030-B70G",
    "hex": "#004E47"
  },
  {
    "name": "NCS S 7010-B70G",
    "hex": "#395250"
  },
  {
    "name": "NCS S 7020-B70G",
    "hex": "#06433D"
  },
  {
    "name": "NCS S 8010-B70G",
    "hex": "#1B3431"
  },
  {
    "name": "NCS S 0505-B80G",
    "hex": "#E5EFEA"
  },
  {
    "name": "NCS S 0507-B80G",
    "hex": "#DEEDE7"
  },
  {
    "name": "NCS S 0515-B80G",
    "hex": "#C6E8DE"
  },
  {
    "name": "NCS S 0907-B80G",
    "hex": "#D3E2DC"
  },
  {
    "name": "NCS S 1005-B80G",
    "hex": "#D1DEDB"
  },
  {
    "name": "NCS S 1015-B80G",
    "hex": "#B9DAD0"
  },
  {
    "name": "NCS S 1040-B80G",
    "hex": "#6DCEB9"
  },
  {
    "name": "NCS S 1050-B80G",
    "hex": "#2DC5AD"
  },
  {
    "name": "NCS S 1510-B80G",
    "hex": "#B6CDC5"
  },
  {
    "name": "NCS S 1515-B80G",
    "hex": "#ABCCC3"
  },
  {
    "name": "NCS S 2005-B80G",
    "hex": "#B8C2BF"
  },
  {
    "name": "NCS S 2040-B80G",
    "hex": "#48B09E"
  },
  {
    "name": "NCS S 2050-B80G",
    "hex": "#00A690"
  },
  {
    "name": "NCS S 2555-B80G",
    "hex": "#00927E"
  },
  {
    "name": "NCS S 3005-B80G",
    "hex": "#9EAAA7"
  },
  {
    "name": "NCS S 3040-B80G",
    "hex": "#2A9586"
  },
  {
    "name": "NCS S 3050-B80G",
    "hex": "#008878"
  },
  {
    "name": "NCS S 3555-B80G",
    "hex": "#007562"
  },
  {
    "name": "NCS S 4005-B80G",
    "hex": "#8B9794"
  },
  {
    "name": "NCS S 4040-B80G",
    "hex": "#007968"
  },
  {
    "name": "NCS S 4050-B80G",
    "hex": "#006C5B"
  },
  {
    "name": "NCS S 4550-B80G",
    "hex": "#00584A"
  },
  {
    "name": "NCS S 5005-B80G",
    "hex": "#798584"
  },
  {
    "name": "NCS S 5040-B80G",
    "hex": "#005C50"
  },
  {
    "name": "NCS S 5540-B80G",
    "hex": "#004839"
  },
  {
    "name": "NCS S 6005-B80G",
    "hex": "#656E6C"
  },
  {
    "name": "NCS S 7005-B80G",
    "hex": "#4B5654"
  },
  {
    "name": "NCS S 8005-B80G",
    "hex": "#2C3936"
  },
  {
    "name": "NCS S 8505-B80G",
    "hex": "#202C29"
  },
  {
    "name": "NCS S 0510-B90G",
    "hex": "#D5ECE2"
  },
  {
    "name": "NCS S 0520-B90G",
    "hex": "#BBE8D6"
  },
  {
    "name": "NCS S 0530-B90G",
    "hex": "#9EE4CB"
  },
  {
    "name": "NCS S 1010-B90G",
    "hex": "#C7DED4"
  },
  {
    "name": "NCS S 1020-B90G",
    "hex": "#ADD7C5"
  },
  {
    "name": "NCS S 1030-B90G",
    "hex": "#92D2BB"
  },
  {
    "name": "NCS S 1040-B90G",
    "hex": "#71CEB2"
  },
  {
    "name": "NCS S 1050-B90G",
    "hex": "#42C4A2"
  },
  {
    "name": "NCS S 1055-B90G",
    "hex": "#10BE98"
  },
  {
    "name": "NCS S 2010-B90G",
    "hex": "#AAC2B9"
  },
  {
    "name": "NCS S 2020-B90G",
    "hex": "#92BBAE"
  },
  {
    "name": "NCS S 2030-B90G",
    "hex": "#77B7A2"
  },
  {
    "name": "NCS S 2040-B90G",
    "hex": "#4FAD94"
  },
  {
    "name": "NCS S 2050-B90G",
    "hex": "#0BA688"
  },
  {
    "name": "NCS S 2060-B90G",
    "hex": "#009A74"
  },
  {
    "name": "NCS S 3010-B90G",
    "hex": "#98ACA5"
  },
  {
    "name": "NCS S 3020-B90G",
    "hex": "#77A394"
  },
  {
    "name": "NCS S 3030-B90G",
    "hex": "#599C89"
  },
  {
    "name": "NCS S 3040-B90G",
    "hex": "#34957D"
  },
  {
    "name": "NCS S 3050-B90G",
    "hex": "#008E71"
  },
  {
    "name": "NCS S 3060-B90G",
    "hex": "#007C5D"
  },
  {
    "name": "NCS S 4010-B90G",
    "hex": "#7D958D"
  },
  {
    "name": "NCS S 4020-B90G",
    "hex": "#648E81"
  },
  {
    "name": "NCS S 4030-B90G",
    "hex": "#468474"
  },
  {
    "name": "NCS S 4040-B90G",
    "hex": "#0D7B64"
  },
  {
    "name": "NCS S 4050-B90G",
    "hex": "#006A51"
  },
  {
    "name": "NCS S 4550-B90G",
    "hex": "#005840"
  },
  {
    "name": "NCS S 5010-B90G",
    "hex": "#687D76"
  },
  {
    "name": "NCS S 5020-B90G",
    "hex": "#4E776A"
  },
  {
    "name": "NCS S 5030-B90G",
    "hex": "#1E6959"
  },
  {
    "name": "NCS S 5040-B90G",
    "hex": "#005B45"
  },
  {
    "name": "NCS S 5540-B90G",
    "hex": "#004E3D"
  },
  {
    "name": "NCS S 6010-B90G",
    "hex": "#536A63"
  },
  {
    "name": "NCS S 6020-B90G",
    "hex": "#335E54"
  },
  {
    "name": "NCS S 6030-B90G",
    "hex": "#005042"
  },
  {
    "name": "NCS S 7010-B90G",
    "hex": "#40534D"
  },
  {
    "name": "NCS S 7020-B90G",
    "hex": "#18443B"
  },
  {
    "name": "NCS S 8010-B90G",
    "hex": "#1D342E"
  },
  {
    "name": "NCS S 0505-G",
    "hex": "#E3ECE3"
  },
  {
    "name": "NCS S 0507-G",
    "hex": "#E2F0E6"
  },
  {
    "name": "NCS S 0510-G",
    "hex": "#DAEFDF"
  },
  {
    "name": "NCS S 0515-G",
    "hex": "#CFEBD8"
  },
  {
    "name": "NCS S 0520-G",
    "hex": "#C3EAD1"
  },
  {
    "name": "NCS S 0530-G",
    "hex": "#A5E0BD"
  },
  {
    "name": "NCS S 0540-G",
    "hex": "#89DCB2"
  },
  {
    "name": "NCS S 1005-G",
    "hex": "#D5DED7"
  },
  {
    "name": "NCS S 1010-G",
    "hex": "#C6DBCE"
  },
  {
    "name": "NCS S 1015-G",
    "hex": "#BCDAC7"
  },
  {
    "name": "NCS S 1020-G",
    "hex": "#ADD7BF"
  },
  {
    "name": "NCS S 1030-G",
    "hex": "#97D2B1"
  },
  {
    "name": "NCS S 1040-G",
    "hex": "#78CBA4"
  },
  {
    "name": "NCS S 1050-G",
    "hex": "#52C395"
  },
  {
    "name": "NCS S 1060-G",
    "hex": "#09B981"
  },
  {
    "name": "NCS S 1510-G",
    "hex": "#BBD0C3"
  },
  {
    "name": "NCS S 1515-G",
    "hex": "#AECCBB"
  },
  {
    "name": "NCS S 1565-G",
    "hex": "#00A268"
  },
  {
    "name": "NCS S 2005-G",
    "hex": "#B9C2BC"
  },
  {
    "name": "NCS S 2010-G",
    "hex": "#AEC2B5"
  },
  {
    "name": "NCS S 2020-G",
    "hex": "#96BEA9"
  },
  {
    "name": "NCS S 2030-G",
    "hex": "#7BB798"
  },
  {
    "name": "NCS S 2040-G",
    "hex": "#5CAF8C"
  },
  {
    "name": "NCS S 2050-G",
    "hex": "#2EA579"
  },
  {
    "name": "NCS S 2060-G",
    "hex": "#009E6B"
  },
  {
    "name": "NCS S 2565-G",
    "hex": "#008850"
  },
  {
    "name": "NCS S 3010-G",
    "hex": "#98ACA1"
  },
  {
    "name": "NCS S 3020-G",
    "hex": "#7CA38E"
  },
  {
    "name": "NCS S 3030-G",
    "hex": "#629B82"
  },
  {
    "name": "NCS S 3040-G",
    "hex": "#449472"
  },
  {
    "name": "NCS S 3050-G",
    "hex": "#008A64"
  },
  {
    "name": "NCS S 3060-G",
    "hex": "#007B4C"
  },
  {
    "name": "NCS S 3560-G",
    "hex": "#006E40"
  },
  {
    "name": "NCS S 4020-G",
    "hex": "#678E7C"
  },
  {
    "name": "NCS S 4030-G",
    "hex": "#49846A"
  },
  {
    "name": "NCS S 4040-G",
    "hex": "#237A5A"
  },
  {
    "name": "NCS S 4050-G",
    "hex": "#006B47"
  },
  {
    "name": "NCS S 4550-G",
    "hex": "#005F3C"
  },
  {
    "name": "NCS S 5020-G",
    "hex": "#517764"
  },
  {
    "name": "NCS S 5030-G",
    "hex": "#326D56"
  },
  {
    "name": "NCS S 5040-G",
    "hex": "#005C3E"
  },
  {
    "name": "NCS S 5540-G",
    "hex": "#005133"
  },
  {
    "name": "NCS S 6020-G",
    "hex": "#395E4D"
  },
  {
    "name": "NCS S 6030-G",
    "hex": "#0D5038"
  },
  {
    "name": "NCS S 7020-G",
    "hex": "#104332"
  },
  {
    "name": "NCS S 0505-G10Y",
    "hex": "#E8EEE6"
  },
  {
    "name": "NCS S 0510-G10Y",
    "hex": "#DDEEDD"
  },
  {
    "name": "NCS S 0520-G10Y",
    "hex": "#C4EACD"
  },
  {
    "name": "NCS S 0530-G10Y",
    "hex": "#AFE2BA"
  },
  {
    "name": "NCS S 0540-G10Y",
    "hex": "#97DDA8"
  },
  {
    "name": "NCS S 0550-G10Y",
    "hex": "#7ED896"
  },
  {
    "name": "NCS S 0560-G10Y",
    "hex": "#5ECA7E"
  },
  {
    "name": "NCS S 0565-G10Y",
    "hex": "#47C374"
  },
  {
    "name": "NCS S 1005-G10Y",
    "hex": "#D5DED5"
  },
  {
    "name": "NCS S 1010-G10Y",
    "hex": "#CADACA"
  },
  {
    "name": "NCS S 1020-G10Y",
    "hex": "#B6D9BC"
  },
  {
    "name": "NCS S 1030-G10Y",
    "hex": "#9FD1A8"
  },
  {
    "name": "NCS S 1040-G10Y",
    "hex": "#85CC9C"
  },
  {
    "name": "NCS S 1050-G10Y",
    "hex": "#6FC788"
  },
  {
    "name": "NCS S 1060-G10Y",
    "hex": "#48B971"
  },
  {
    "name": "NCS S 1070-G10Y",
    "hex": "#00AC5B"
  },
  {
    "name": "NCS S 2005-G10Y",
    "hex": "#BAC2BA"
  },
  {
    "name": "NCS S 2010-G10Y",
    "hex": "#B1C4B6"
  },
  {
    "name": "NCS S 2020-G10Y",
    "hex": "#9DBDA2"
  },
  {
    "name": "NCS S 2030-G10Y",
    "hex": "#82B693"
  },
  {
    "name": "NCS S 2040-G10Y",
    "hex": "#6BB182"
  },
  {
    "name": "NCS S 2050-G10Y",
    "hex": "#4AA671"
  },
  {
    "name": "NCS S 2060-G10Y",
    "hex": "#0E9C5D"
  },
  {
    "name": "NCS S 2070-G10Y",
    "hex": "#008E44"
  },
  {
    "name": "NCS S 3010-G10Y",
    "hex": "#97A999"
  },
  {
    "name": "NCS S 3020-G10Y",
    "hex": "#8AA68E"
  },
  {
    "name": "NCS S 3030-G10Y",
    "hex": "#71A37F"
  },
  {
    "name": "NCS S 3040-G10Y",
    "hex": "#52966A"
  },
  {
    "name": "NCS S 3050-G10Y",
    "hex": "#2D8B58"
  },
  {
    "name": "NCS S 3060-G10Y",
    "hex": "#008145"
  },
  {
    "name": "NCS S 3065-G10Y",
    "hex": "#00752F"
  },
  {
    "name": "NCS S 3560-G10Y",
    "hex": "#006C36"
  },
  {
    "name": "NCS S 4010-G10Y",
    "hex": "#829486"
  },
  {
    "name": "NCS S 4020-G10Y",
    "hex": "#6C9077"
  },
  {
    "name": "NCS S 4030-G10Y",
    "hex": "#548665"
  },
  {
    "name": "NCS S 4040-G10Y",
    "hex": "#357C52"
  },
  {
    "name": "NCS S 4050-G10Y",
    "hex": "#157141"
  },
  {
    "name": "NCS S 4550-G10Y",
    "hex": "#005C2A"
  },
  {
    "name": "NCS S 5010-G10Y",
    "hex": "#6D7F72"
  },
  {
    "name": "NCS S 5020-G10Y",
    "hex": "#557660"
  },
  {
    "name": "NCS S 5030-G10Y",
    "hex": "#3C6F50"
  },
  {
    "name": "NCS S 5040-G10Y",
    "hex": "#166038"
  },
  {
    "name": "NCS S 5540-G10Y",
    "hex": "#005130"
  },
  {
    "name": "NCS S 6010-G10Y",
    "hex": "#57695E"
  },
  {
    "name": "NCS S 6020-G10Y",
    "hex": "#3D604B"
  },
  {
    "name": "NCS S 6030-G10Y",
    "hex": "#1D5536"
  },
  {
    "name": "NCS S 6530-G10Y",
    "hex": "#16482D"
  },
  {
    "name": "NCS S 7010-G10Y",
    "hex": "#455649"
  },
  {
    "name": "NCS S 7020-G10Y",
    "hex": "#254631"
  },
  {
    "name": "NCS S 8010-G10Y",
    "hex": "#243629"
  },
  {
    "name": "NCS S 0505-G20Y",
    "hex": "#E5ECE0"
  },
  {
    "name": "NCS S 0510-G20Y",
    "hex": "#E0EDDC"
  },
  {
    "name": "NCS S 0515-G20Y",
    "hex": "#D4EAD0"
  },
  {
    "name": "NCS S 0520-G20Y",
    "hex": "#CDE9C7"
  },
  {
    "name": "NCS S 0530-G20Y",
    "hex": "#B2E2B0"
  },
  {
    "name": "NCS S 0540-G20Y",
    "hex": "#A2DFA1"
  },
  {
    "name": "NCS S 0550-G20Y",
    "hex": "#8FD68A"
  },
  {
    "name": "NCS S 0560-G20Y",
    "hex": "#7ED373"
  },
  {
    "name": "NCS S 0570-G20Y",
    "hex": "#59C256"
  },
  {
    "name": "NCS S 0575-G20Y",
    "hex": "#49BE43"
  },
  {
    "name": "NCS S 0804-G20Y",
    "hex": "#DDE3DB"
  },
  {
    "name": "NCS S 0907-G20Y",
    "hex": "#D7E1D4"
  },
  {
    "name": "NCS S 1005-G20Y",
    "hex": "#D6DDD3"
  },
  {
    "name": "NCS S 1010-G20Y",
    "hex": "#CDDDCB"
  },
  {
    "name": "NCS S 1015-G20Y",
    "hex": "#C3D9BF"
  },
  {
    "name": "NCS S 1020-G20Y",
    "hex": "#BAD8B7"
  },
  {
    "name": "NCS S 1030-G20Y",
    "hex": "#A6D0A2"
  },
  {
    "name": "NCS S 1040-G20Y",
    "hex": "#92CB8F"
  },
  {
    "name": "NCS S 1050-G20Y",
    "hex": "#81C57D"
  },
  {
    "name": "NCS S 1060-G20Y",
    "hex": "#66BD64"
  },
  {
    "name": "NCS S 1070-G20Y",
    "hex": "#4CB750"
  },
  {
    "name": "NCS S 1075-G20Y",
    "hex": "#3AAD3D"
  },
  {
    "name": "NCS S 1510-G20Y",
    "hex": "#BFCFBD"
  },
  {
    "name": "NCS S 1515-G20Y",
    "hex": "#B5CBB4"
  },
  {
    "name": "NCS S 2005-G20Y",
    "hex": "#BCC4BC"
  },
  {
    "name": "NCS S 2010-G20Y",
    "hex": "#B1C1B1"
  },
  {
    "name": "NCS S 2020-G20Y",
    "hex": "#9EBC9E"
  },
  {
    "name": "NCS S 2030-G20Y",
    "hex": "#8AB48A"
  },
  {
    "name": "NCS S 2040-G20Y",
    "hex": "#7AAE7A"
  },
  {
    "name": "NCS S 2050-G20Y",
    "hex": "#61A763"
  },
  {
    "name": "NCS S 2060-G20Y",
    "hex": "#489E4F"
  },
  {
    "name": "NCS S 2070-G20Y",
    "hex": "#29963A"
  },
  {
    "name": "NCS S 2075-G20Y",
    "hex": "#04922E"
  },
  {
    "name": "NCS S 2570-G20Y",
    "hex": "#148630"
  },
  {
    "name": "NCS S 3005-G20Y",
    "hex": "#A7AFA7"
  },
  {
    "name": "NCS S 3010-G20Y",
    "hex": "#99A999"
  },
  {
    "name": "NCS S 3020-G20Y",
    "hex": "#89A486"
  },
  {
    "name": "NCS S 3030-G20Y",
    "hex": "#709D75"
  },
  {
    "name": "NCS S 3040-G20Y",
    "hex": "#609764"
  },
  {
    "name": "NCS S 3050-G20Y",
    "hex": "#4C8E52"
  },
  {
    "name": "NCS S 3060-G20Y",
    "hex": "#2D843B"
  },
  {
    "name": "NCS S 3560-G20Y",
    "hex": "#1B7432"
  },
  {
    "name": "NCS S 4005-G20Y",
    "hex": "#8F978F"
  },
  {
    "name": "NCS S 4040-G20Y",
    "hex": "#4A7C4C"
  },
  {
    "name": "NCS S 4050-G20Y",
    "hex": "#2F7238"
  },
  {
    "name": "NCS S 4550-G20Y",
    "hex": "#1B602A"
  },
  {
    "name": "NCS S 5005-G20Y",
    "hex": "#798379"
  },
  {
    "name": "NCS S 5040-G20Y",
    "hex": "#2B6134"
  },
  {
    "name": "NCS S 5540-G20Y",
    "hex": "#1C5325"
  },
  {
    "name": "NCS S 6005-G20Y",
    "hex": "#656E65"
  },
  {
    "name": "NCS S 7005-G20Y",
    "hex": "#4F5951"
  },
  {
    "name": "NCS S 8005-G20Y",
    "hex": "#343D36"
  },
  {
    "name": "NCS S 8505-G20Y",
    "hex": "#232E27"
  },
  {
    "name": "NCS S 0505-G30Y",
    "hex": "#E5ECE0"
  },
  {
    "name": "NCS S 0510-G30Y",
    "hex": "#E2EDD6"
  },
  {
    "name": "NCS S 0520-G30Y",
    "hex": "#D3E7C0"
  },
  {
    "name": "NCS S 0530-G30Y",
    "hex": "#BFE3AA"
  },
  {
    "name": "NCS S 0540-G30Y",
    "hex": "#ADDD94"
  },
  {
    "name": "NCS S 0550-G30Y",
    "hex": "#A3D67C"
  },
  {
    "name": "NCS S 0560-G30Y",
    "hex": "#93D065"
  },
  {
    "name": "NCS S 0570-G30Y",
    "hex": "#80CA4D"
  },
  {
    "name": "NCS S 0580-G30Y",
    "hex": "#6CC120"
  },
  {
    "name": "NCS S 1005-G30Y",
    "hex": "#D7DDD2"
  },
  {
    "name": "NCS S 1010-G30Y",
    "hex": "#D1DCC5"
  },
  {
    "name": "NCS S 1020-G30Y",
    "hex": "#BFD7B3"
  },
  {
    "name": "NCS S 1030-G30Y",
    "hex": "#ACCF9B"
  },
  {
    "name": "NCS S 1040-G30Y",
    "hex": "#A1CF8A"
  },
  {
    "name": "NCS S 1050-G30Y",
    "hex": "#94C875"
  },
  {
    "name": "NCS S 1060-G30Y",
    "hex": "#84C25C"
  },
  {
    "name": "NCS S 1070-G30Y",
    "hex": "#70B33F"
  },
  {
    "name": "NCS S 1080-G30Y",
    "hex": "#58AD00"
  },
  {
    "name": "NCS S 2005-G30Y",
    "hex": "#BDC4BB"
  },
  {
    "name": "NCS S 2010-G30Y",
    "hex": "#B4C0AE"
  },
  {
    "name": "NCS S 2020-G30Y",
    "hex": "#A9BE9B"
  },
  {
    "name": "NCS S 2030-G30Y",
    "hex": "#96B685"
  },
  {
    "name": "NCS S 2040-G30Y",
    "hex": "#88B373"
  },
  {
    "name": "NCS S 2050-G30Y",
    "hex": "#78A658"
  },
  {
    "name": "NCS S 2060-G30Y",
    "hex": "#69A046"
  },
  {
    "name": "NCS S 2070-G30Y",
    "hex": "#5B9A2E"
  },
  {
    "name": "NCS S 2075-G30Y",
    "hex": "#459415"
  },
  {
    "name": "NCS S 2570-G30Y",
    "hex": "#4F8C29"
  },
  {
    "name": "NCS S 3010-G30Y",
    "hex": "#A1AD9B"
  },
  {
    "name": "NCS S 3020-G30Y",
    "hex": "#91A584"
  },
  {
    "name": "NCS S 3030-G30Y",
    "hex": "#7E9D6E"
  },
  {
    "name": "NCS S 3040-G30Y",
    "hex": "#6F985D"
  },
  {
    "name": "NCS S 3050-G30Y",
    "hex": "#5F8C46"
  },
  {
    "name": "NCS S 3060-G30Y",
    "hex": "#52852E"
  },
  {
    "name": "NCS S 3560-G30Y",
    "hex": "#47782C"
  },
  {
    "name": "NCS S 4010-G30Y",
    "hex": "#879381"
  },
  {
    "name": "NCS S 4020-G30Y",
    "hex": "#788E6F"
  },
  {
    "name": "NCS S 4030-G30Y",
    "hex": "#66865C"
  },
  {
    "name": "NCS S 4040-G30Y",
    "hex": "#588048"
  },
  {
    "name": "NCS S 4050-G30Y",
    "hex": "#477232"
  },
  {
    "name": "NCS S 4550-G30Y",
    "hex": "#3A6528"
  },
  {
    "name": "NCS S 5010-G30Y",
    "hex": "#758171"
  },
  {
    "name": "NCS S 5020-G30Y",
    "hex": "#647A5B"
  },
  {
    "name": "NCS S 5030-G30Y",
    "hex": "#536F45"
  },
  {
    "name": "NCS S 5040-G30Y",
    "hex": "#436634"
  },
  {
    "name": "NCS S 5540-G30Y",
    "hex": "#385A2C"
  },
  {
    "name": "NCS S 6010-G30Y",
    "hex": "#5F6A5B"
  },
  {
    "name": "NCS S 6020-G30Y",
    "hex": "#4D6044"
  },
  {
    "name": "NCS S 6030-G30Y",
    "hex": "#3E5835"
  },
  {
    "name": "NCS S 7010-G30Y",
    "hex": "#475244"
  },
  {
    "name": "NCS S 7020-G30Y",
    "hex": "#334729"
  },
  {
    "name": "NCS S 8010-G30Y",
    "hex": "#2B3A2A"
  },
  {
    "name": "NCS S 0505-G40Y",
    "hex": "#EEF1E1"
  },
  {
    "name": "NCS S 0507-G40Y",
    "hex": "#EAEEDB"
  },
  {
    "name": "NCS S 0510-G40Y",
    "hex": "#E8EFD5"
  },
  {
    "name": "NCS S 0515-G40Y",
    "hex": "#E3EECC"
  },
  {
    "name": "NCS S 0520-G40Y",
    "hex": "#DBE9BB"
  },
  {
    "name": "NCS S 0530-G40Y",
    "hex": "#CFE6A7"
  },
  {
    "name": "NCS S 0540-G40Y",
    "hex": "#C3E08D"
  },
  {
    "name": "NCS S 0550-G40Y",
    "hex": "#B9DC75"
  },
  {
    "name": "NCS S 0560-G40Y",
    "hex": "#AAD25B"
  },
  {
    "name": "NCS S 0570-G40Y",
    "hex": "#96CA36"
  },
  {
    "name": "NCS S 0575-G40Y",
    "hex": "#9ACC29"
  },
  {
    "name": "NCS S 0603-G40Y",
    "hex": "#E8EAE2"
  },
  {
    "name": "NCS S 1005-G40Y",
    "hex": "#DBE0D4"
  },
  {
    "name": "NCS S 1010-G40Y",
    "hex": "#D1DCC3"
  },
  {
    "name": "NCS S 1015-G40Y",
    "hex": "#D2DDBC"
  },
  {
    "name": "NCS S 1020-G40Y",
    "hex": "#C6D6AC"
  },
  {
    "name": "NCS S 1030-G40Y",
    "hex": "#BCD299"
  },
  {
    "name": "NCS S 1040-G40Y",
    "hex": "#B2CB7F"
  },
  {
    "name": "NCS S 1050-G40Y",
    "hex": "#A3C567"
  },
  {
    "name": "NCS S 1060-G40Y",
    "hex": "#9EC453"
  },
  {
    "name": "NCS S 1070-G40Y",
    "hex": "#90BA31"
  },
  {
    "name": "NCS S 1075-G40Y",
    "hex": "#88B50A"
  },
  {
    "name": "NCS S 1510-G40Y",
    "hex": "#C8D0BA"
  },
  {
    "name": "NCS S 1515-G40Y",
    "hex": "#C1CCAD"
  },
  {
    "name": "NCS S 2005-G40Y",
    "hex": "#C2C7BC"
  },
  {
    "name": "NCS S 2010-G40Y",
    "hex": "#BBC2AF"
  },
  {
    "name": "NCS S 2020-G40Y",
    "hex": "#AFBC96"
  },
  {
    "name": "NCS S 2030-G40Y",
    "hex": "#A2B680"
  },
  {
    "name": "NCS S 2040-G40Y",
    "hex": "#97B067"
  },
  {
    "name": "NCS S 2050-G40Y",
    "hex": "#8EAC54"
  },
  {
    "name": "NCS S 2060-G40Y",
    "hex": "#80A23D"
  },
  {
    "name": "NCS S 2070-G40Y",
    "hex": "#719922"
  },
  {
    "name": "NCS S 3010-G40Y",
    "hex": "#A2AA95"
  },
  {
    "name": "NCS S 3020-G40Y",
    "hex": "#97A47E"
  },
  {
    "name": "NCS S 3030-G40Y",
    "hex": "#8A9E6B"
  },
  {
    "name": "NCS S 3040-G40Y",
    "hex": "#829A59"
  },
  {
    "name": "NCS S 3050-G40Y",
    "hex": "#728E3F"
  },
  {
    "name": "NCS S 3060-G40Y",
    "hex": "#698728"
  },
  {
    "name": "NCS S 3065-G40Y",
    "hex": "#5E801A"
  },
  {
    "name": "NCS S 3560-G40Y",
    "hex": "#5B7A25"
  },
  {
    "name": "NCS S 4040-G40Y",
    "hex": "#6A8043"
  },
  {
    "name": "NCS S 4050-G40Y",
    "hex": "#5B7729"
  },
  {
    "name": "NCS S 4550-G40Y",
    "hex": "#516A26"
  },
  {
    "name": "NCS S 5040-G40Y",
    "hex": "#51672C"
  },
  {
    "name": "NCS S 5540-G40Y",
    "hex": "#445B1C"
  },
  {
    "name": "NCS S 0505-G50Y",
    "hex": "#EEF1DF"
  },
  {
    "name": "NCS S 0510-G50Y",
    "hex": "#E6ECD4"
  },
  {
    "name": "NCS S 0520-G50Y",
    "hex": "#E2EFBA"
  },
  {
    "name": "NCS S 0530-G50Y",
    "hex": "#D5E59E"
  },
  {
    "name": "NCS S 0540-G50Y",
    "hex": "#CFE088"
  },
  {
    "name": "NCS S 0550-G50Y",
    "hex": "#C5DD6E"
  },
  {
    "name": "NCS S 0560-G50Y",
    "hex": "#BFD856"
  },
  {
    "name": "NCS S 0565-G50Y",
    "hex": "#B4D03B"
  },
  {
    "name": "NCS S 1005-G50Y",
    "hex": "#DADDCC"
  },
  {
    "name": "NCS S 1010-G50Y",
    "hex": "#D7DEC2"
  },
  {
    "name": "NCS S 1020-G50Y",
    "hex": "#D2DDAE"
  },
  {
    "name": "NCS S 1030-G50Y",
    "hex": "#C5D492"
  },
  {
    "name": "NCS S 1040-G50Y",
    "hex": "#BDD07C"
  },
  {
    "name": "NCS S 1050-G50Y",
    "hex": "#B6CB62"
  },
  {
    "name": "NCS S 1060-G50Y",
    "hex": "#AFC74B"
  },
  {
    "name": "NCS S 1070-G50Y",
    "hex": "#A4BC25"
  },
  {
    "name": "NCS S 1075-G50Y",
    "hex": "#9CB700"
  },
  {
    "name": "NCS S 2005-G50Y",
    "hex": "#C0C4B7"
  },
  {
    "name": "NCS S 2010-G50Y",
    "hex": "#BDC2AB"
  },
  {
    "name": "NCS S 2020-G50Y",
    "hex": "#B2BC92"
  },
  {
    "name": "NCS S 2030-G50Y",
    "hex": "#ADBA80"
  },
  {
    "name": "NCS S 2040-G50Y",
    "hex": "#A3B467"
  },
  {
    "name": "NCS S 2050-G50Y",
    "hex": "#9DAF51"
  },
  {
    "name": "NCS S 2060-G50Y",
    "hex": "#90A537"
  },
  {
    "name": "NCS S 2070-G50Y",
    "hex": "#859E13"
  },
  {
    "name": "NCS S 3005-G50Y",
    "hex": "#A8AB9F"
  },
  {
    "name": "NCS S 3010-G50Y",
    "hex": "#A2AA93"
  },
  {
    "name": "NCS S 3020-G50Y",
    "hex": "#9FA97E"
  },
  {
    "name": "NCS S 3030-G50Y",
    "hex": "#96A26B"
  },
  {
    "name": "NCS S 3040-G50Y",
    "hex": "#8F9E57"
  },
  {
    "name": "NCS S 3050-G50Y",
    "hex": "#85943F"
  },
  {
    "name": "NCS S 3060-G50Y",
    "hex": "#798A1E"
  },
  {
    "name": "NCS S 3065-G50Y",
    "hex": "#71860A"
  },
  {
    "name": "NCS S 3560-G50Y",
    "hex": "#6F7F21"
  },
  {
    "name": "NCS S 4005-G50Y",
    "hex": "#939688"
  },
  {
    "name": "NCS S 4010-G50Y",
    "hex": "#8E9482"
  },
  {
    "name": "NCS S 4020-G50Y",
    "hex": "#899169"
  },
  {
    "name": "NCS S 4030-G50Y",
    "hex": "#7C8854"
  },
  {
    "name": "NCS S 4040-G50Y",
    "hex": "#758040"
  },
  {
    "name": "NCS S 4050-G50Y",
    "hex": "#697728"
  },
  {
    "name": "NCS S 4550-G50Y",
    "hex": "#606D23"
  },
  {
    "name": "NCS S 5005-G50Y",
    "hex": "#818478"
  },
  {
    "name": "NCS S 5010-G50Y",
    "hex": "#7B7F6E"
  },
  {
    "name": "NCS S 5020-G50Y",
    "hex": "#707754"
  },
  {
    "name": "NCS S 5030-G50Y",
    "hex": "#687041"
  },
  {
    "name": "NCS S 5040-G50Y",
    "hex": "#5B672A"
  },
  {
    "name": "NCS S 5540-G50Y",
    "hex": "#525A25"
  },
  {
    "name": "NCS S 6005-G50Y",
    "hex": "#6F7268"
  },
  {
    "name": "NCS S 6010-G50Y",
    "hex": "#676B5A"
  },
  {
    "name": "NCS S 6020-G50Y",
    "hex": "#5C6343"
  },
  {
    "name": "NCS S 6030-G50Y",
    "hex": "#4E582A"
  },
  {
    "name": "NCS S 6530-G50Y",
    "hex": "#464E23"
  },
  {
    "name": "NCS S 7005-G50Y",
    "hex": "#54584E"
  },
  {
    "name": "NCS S 7010-G50Y",
    "hex": "#525644"
  },
  {
    "name": "NCS S 7020-G50Y",
    "hex": "#414625"
  },
  {
    "name": "NCS S 8005-G50Y",
    "hex": "#383C33"
  },
  {
    "name": "NCS S 8010-G50Y",
    "hex": "#333825"
  },
  {
    "name": "NCS S 0505-G60Y",
    "hex": "#EEF1DF"
  },
  {
    "name": "NCS S 0510-G60Y",
    "hex": "#E8ECD0"
  },
  {
    "name": "NCS S 0515-G60Y",
    "hex": "#E5EAC0"
  },
  {
    "name": "NCS S 0520-G60Y",
    "hex": "#E3EBB6"
  },
  {
    "name": "NCS S 0530-G60Y",
    "hex": "#DDE79B"
  },
  {
    "name": "NCS S 0540-G60Y",
    "hex": "#DCE884"
  },
  {
    "name": "NCS S 0550-G60Y",
    "hex": "#D5E36B"
  },
  {
    "name": "NCS S 0560-G60Y",
    "hex": "#D1DE4E"
  },
  {
    "name": "NCS S 0570-G60Y",
    "hex": "#C5D727"
  },
  {
    "name": "NCS S 0575-G60Y",
    "hex": "#C3D400"
  },
  {
    "name": "NCS S 0804-G60Y",
    "hex": "#E4E5D8"
  },
  {
    "name": "NCS S 0907-G60Y",
    "hex": "#DFE3CE"
  },
  {
    "name": "NCS S 1005-G60Y",
    "hex": "#DDE0D1"
  },
  {
    "name": "NCS S 1010-G60Y",
    "hex": "#DADEC0"
  },
  {
    "name": "NCS S 1015-G60Y",
    "hex": "#D6DCB4"
  },
  {
    "name": "NCS S 1020-G60Y",
    "hex": "#D4D9A8"
  },
  {
    "name": "NCS S 1030-G60Y",
    "hex": "#D0D891"
  },
  {
    "name": "NCS S 1040-G60Y",
    "hex": "#C6D177"
  },
  {
    "name": "NCS S 1050-G60Y",
    "hex": "#C2CF5F"
  },
  {
    "name": "NCS S 1060-G60Y",
    "hex": "#BCCB44"
  },
  {
    "name": "NCS S 1070-G60Y",
    "hex": "#B3C325"
  },
  {
    "name": "NCS S 1075-G60Y",
    "hex": "#B2C000"
  },
  {
    "name": "NCS S 1510-G60Y",
    "hex": "#CBD0B5"
  },
  {
    "name": "NCS S 1515-G60Y",
    "hex": "#C8CEA8"
  },
  {
    "name": "NCS S 2005-G60Y",
    "hex": "#C0C4B7"
  },
  {
    "name": "NCS S 2010-G60Y",
    "hex": "#BCBFA8"
  },
  {
    "name": "NCS S 2020-G60Y",
    "hex": "#B9BD91"
  },
  {
    "name": "NCS S 2030-G60Y",
    "hex": "#B6BC79"
  },
  {
    "name": "NCS S 2040-G60Y",
    "hex": "#ACB564"
  },
  {
    "name": "NCS S 2050-G60Y",
    "hex": "#A6B04E"
  },
  {
    "name": "NCS S 2060-G60Y",
    "hex": "#A1AB30"
  },
  {
    "name": "NCS S 2070-G60Y",
    "hex": "#99A300"
  },
  {
    "name": "NCS S 3010-G60Y",
    "hex": "#A7AC94"
  },
  {
    "name": "NCS S 3020-G60Y",
    "hex": "#A0A57C"
  },
  {
    "name": "NCS S 3030-G60Y",
    "hex": "#9BA166"
  },
  {
    "name": "NCS S 3040-G60Y",
    "hex": "#959C4F"
  },
  {
    "name": "NCS S 3050-G60Y",
    "hex": "#8E9537"
  },
  {
    "name": "NCS S 3060-G60Y",
    "hex": "#889022"
  },
  {
    "name": "NCS S 3065-G60Y",
    "hex": "#868D18"
  },
  {
    "name": "NCS S 3560-G60Y",
    "hex": "#7C821C"
  },
  {
    "name": "NCS S 4040-G60Y",
    "hex": "#808441"
  },
  {
    "name": "NCS S 4050-G60Y",
    "hex": "#797D27"
  },
  {
    "name": "NCS S 4550-G60Y",
    "hex": "#6F7221"
  },
  {
    "name": "NCS S 5040-G60Y",
    "hex": "#676A2D"
  },
  {
    "name": "NCS S 5540-G60Y",
    "hex": "#5B5E20"
  },
  {
    "name": "NCS S 0505-G70Y",
    "hex": "#EBEEDD"
  },
  {
    "name": "NCS S 0510-G70Y",
    "hex": "#F0F1CE"
  },
  {
    "name": "NCS S 0520-G70Y",
    "hex": "#EDF0B5"
  },
  {
    "name": "NCS S 0530-G70Y",
    "hex": "#EBEE9D"
  },
  {
    "name": "NCS S 0540-G70Y",
    "hex": "#E3EA83"
  },
  {
    "name": "NCS S 0550-G70Y",
    "hex": "#E2E76A"
  },
  {
    "name": "NCS S 0560-G70Y",
    "hex": "#DDE24C"
  },
  {
    "name": "NCS S 0570-G70Y",
    "hex": "#D6DD17"
  },
  {
    "name": "NCS S 0575-G70Y",
    "hex": "#CFD400"
  },
  {
    "name": "NCS S 1005-G70Y",
    "hex": "#E1E2D3"
  },
  {
    "name": "NCS S 1010-G70Y",
    "hex": "#DCDDBE"
  },
  {
    "name": "NCS S 1020-G70Y",
    "hex": "#D9DCA8"
  },
  {
    "name": "NCS S 1030-G70Y",
    "hex": "#D5D78D"
  },
  {
    "name": "NCS S 1040-G70Y",
    "hex": "#CFD272"
  },
  {
    "name": "NCS S 1050-G70Y",
    "hex": "#CFD35C"
  },
  {
    "name": "NCS S 1060-G70Y",
    "hex": "#C5C83D"
  },
  {
    "name": "NCS S 1070-G70Y",
    "hex": "#C3C509"
  },
  {
    "name": "NCS S 1075-G70Y",
    "hex": "#C1C300"
  },
  {
    "name": "NCS S 2005-G70Y",
    "hex": "#C1C4B5"
  },
  {
    "name": "NCS S 2010-G70Y",
    "hex": "#C0C1A5"
  },
  {
    "name": "NCS S 2020-G70Y",
    "hex": "#BDC08E"
  },
  {
    "name": "NCS S 2030-G70Y",
    "hex": "#B9BB79"
  },
  {
    "name": "NCS S 2040-G70Y",
    "hex": "#B6B65E"
  },
  {
    "name": "NCS S 2050-G70Y",
    "hex": "#B5B74D"
  },
  {
    "name": "NCS S 2060-G70Y",
    "hex": "#ABAC2E"
  },
  {
    "name": "NCS S 2070-G70Y",
    "hex": "#A5A70F"
  },
  {
    "name": "NCS S 3010-G70Y",
    "hex": "#AAAC92"
  },
  {
    "name": "NCS S 3020-G70Y",
    "hex": "#A4A47A"
  },
  {
    "name": "NCS S 3030-G70Y",
    "hex": "#A2A265"
  },
  {
    "name": "NCS S 3040-G70Y",
    "hex": "#9B9B4F"
  },
  {
    "name": "NCS S 3050-G70Y",
    "hex": "#969637"
  },
  {
    "name": "NCS S 3060-G70Y",
    "hex": "#959322"
  },
  {
    "name": "NCS S 3560-G70Y",
    "hex": "#7F7E00"
  },
  {
    "name": "NCS S 4010-G70Y",
    "hex": "#96967F"
  },
  {
    "name": "NCS S 4020-G70Y",
    "hex": "#929168"
  },
  {
    "name": "NCS S 4030-G70Y",
    "hex": "#8E8D55"
  },
  {
    "name": "NCS S 4040-G70Y",
    "hex": "#83833F"
  },
  {
    "name": "NCS S 4050-G70Y",
    "hex": "#817D25"
  },
  {
    "name": "NCS S 4550-G70Y",
    "hex": "#73711F"
  },
  {
    "name": "NCS S 5010-G70Y",
    "hex": "#81816B"
  },
  {
    "name": "NCS S 5020-G70Y",
    "hex": "#7A7A56"
  },
  {
    "name": "NCS S 5030-G70Y",
    "hex": "#75733F"
  },
  {
    "name": "NCS S 5040-G70Y",
    "hex": "#6B6928"
  },
  {
    "name": "NCS S 5540-G70Y",
    "hex": "#5E5D20"
  },
  {
    "name": "NCS S 6010-G70Y",
    "hex": "#6D6D58"
  },
  {
    "name": "NCS S 6020-G70Y",
    "hex": "#656441"
  },
  {
    "name": "NCS S 6030-G70Y",
    "hex": "#5B5A2D"
  },
  {
    "name": "NCS S 7010-G70Y",
    "hex": "#54523E"
  },
  {
    "name": "NCS S 7020-G70Y",
    "hex": "#484726"
  },
  {
    "name": "NCS S 8010-G70Y",
    "hex": "#3D3E2D"
  },
  {
    "name": "NCS S 0505-G80Y",
    "hex": "#EEEDDB"
  },
  {
    "name": "NCS S 0507-G80Y",
    "hex": "#EEEED5"
  },
  {
    "name": "NCS S 0510-G80Y",
    "hex": "#EFEECB"
  },
  {
    "name": "NCS S 0515-G80Y",
    "hex": "#EDEBBD"
  },
  {
    "name": "NCS S 0520-G80Y",
    "hex": "#F0EBB1"
  },
  {
    "name": "NCS S 0530-G80Y",
    "hex": "#EEE99A"
  },
  {
    "name": "NCS S 0540-G80Y",
    "hex": "#EDE77F"
  },
  {
    "name": "NCS S 0550-G80Y",
    "hex": "#E7E263"
  },
  {
    "name": "NCS S 0560-G80Y",
    "hex": "#E5DC44"
  },
  {
    "name": "NCS S 0570-G80Y",
    "hex": "#E2D91A"
  },
  {
    "name": "NCS S 0603-G80Y",
    "hex": "#EBEADE"
  },
  {
    "name": "NCS S 1005-G80Y",
    "hex": "#DFDFCF"
  },
  {
    "name": "NCS S 1010-G80Y",
    "hex": "#DFDCBD"
  },
  {
    "name": "NCS S 1015-G80Y",
    "hex": "#E0DDB1"
  },
  {
    "name": "NCS S 1020-G80Y",
    "hex": "#DEDAA3"
  },
  {
    "name": "NCS S 1030-G80Y",
    "hex": "#DED88C"
  },
  {
    "name": "NCS S 1040-G80Y",
    "hex": "#DBD673"
  },
  {
    "name": "NCS S 1050-G80Y",
    "hex": "#D5CD5A"
  },
  {
    "name": "NCS S 1060-G80Y",
    "hex": "#D1C83E"
  },
  {
    "name": "NCS S 1070-G80Y",
    "hex": "#D2C80A"
  },
  {
    "name": "NCS S 1075-G80Y",
    "hex": "#CCC300"
  },
  {
    "name": "NCS S 1505-G80Y",
    "hex": "#D1D1C1"
  },
  {
    "name": "NCS S 1510-G80Y",
    "hex": "#D3D1B4"
  },
  {
    "name": "NCS S 1515-G80Y",
    "hex": "#D2CFA6"
  },
  {
    "name": "NCS S 2005-G80Y",
    "hex": "#C7C6B4"
  },
  {
    "name": "NCS S 2010-G80Y",
    "hex": "#C5C3A6"
  },
  {
    "name": "NCS S 2020-G80Y",
    "hex": "#C3BE8C"
  },
  {
    "name": "NCS S 2030-G80Y",
    "hex": "#C0B974"
  },
  {
    "name": "NCS S 2040-G80Y",
    "hex": "#C1B960"
  },
  {
    "name": "NCS S 2050-G80Y",
    "hex": "#B6AF46"
  },
  {
    "name": "NCS S 2060-G80Y",
    "hex": "#B7AC2C"
  },
  {
    "name": "NCS S 2070-G80Y",
    "hex": "#B0A300"
  },
  {
    "name": "NCS S 3005-G80Y",
    "hex": "#B1B09F"
  },
  {
    "name": "NCS S 3010-G80Y",
    "hex": "#AEAA92"
  },
  {
    "name": "NCS S 3020-G80Y",
    "hex": "#ACA577"
  },
  {
    "name": "NCS S 3030-G80Y",
    "hex": "#AAA061"
  },
  {
    "name": "NCS S 3040-G80Y",
    "hex": "#A89D4D"
  },
  {
    "name": "NCS S 3050-G80Y",
    "hex": "#A09636"
  },
  {
    "name": "NCS S 3060-G80Y",
    "hex": "#998E1D"
  },
  {
    "name": "NCS S 4005-G80Y",
    "hex": "#969585"
  },
  {
    "name": "NCS S 4040-G80Y",
    "hex": "#8B8136"
  },
  {
    "name": "NCS S 4050-G80Y",
    "hex": "#83791B"
  },
  {
    "name": "NCS S 5005-G80Y",
    "hex": "#858375"
  },
  {
    "name": "NCS S 5040-G80Y",
    "hex": "#6E651A"
  },
  {
    "name": "NCS S 6005-G80Y",
    "hex": "#716F63"
  },
  {
    "name": "NCS S 7005-G80Y",
    "hex": "#5B594D"
  },
  {
    "name": "NCS S 8005-G80Y",
    "hex": "#3E3D34"
  },
  {
    "name": "NCS S 8505-G80Y",
    "hex": "#2D2C23"
  },
  {
    "name": "NCS S 0505-G90Y",
    "hex": "#F7F2DD"
  },
  {
    "name": "NCS S 0510-G90Y",
    "hex": "#F2EDCB"
  },
  {
    "name": "NCS S 0515-G90Y",
    "hex": "#F4EDBE"
  },
  {
    "name": "NCS S 0520-G90Y",
    "hex": "#F1E7AC"
  },
  {
    "name": "NCS S 0530-G90Y",
    "hex": "#FAED9A"
  },
  {
    "name": "NCS S 0540-G90Y",
    "hex": "#F8E77E"
  },
  {
    "name": "NCS S 0550-G90Y",
    "hex": "#F1DF64"
  },
  {
    "name": "NCS S 0560-G90Y",
    "hex": "#F1DC45"
  },
  {
    "name": "NCS S 0570-G90Y",
    "hex": "#F5DB16"
  },
  {
    "name": "NCS S 0575-G90Y",
    "hex": "#F0D500"
  },
  {
    "name": "NCS S 0804-G90Y",
    "hex": "#E7E4D2"
  },
  {
    "name": "NCS S 0907-G90Y",
    "hex": "#E5E2C8"
  },
  {
    "name": "NCS S 1005-G90Y",
    "hex": "#E0DFCB"
  },
  {
    "name": "NCS S 1010-G90Y",
    "hex": "#E1DCBB"
  },
  {
    "name": "NCS S 1015-G90Y",
    "hex": "#E5DBAD"
  },
  {
    "name": "NCS S 1020-G90Y",
    "hex": "#E7DBA4"
  },
  {
    "name": "NCS S 1030-G90Y",
    "hex": "#E4D68B"
  },
  {
    "name": "NCS S 1040-G90Y",
    "hex": "#E2D473"
  },
  {
    "name": "NCS S 1050-G90Y",
    "hex": "#DFCE56"
  },
  {
    "name": "NCS S 1060-G90Y",
    "hex": "#E0CA3F"
  },
  {
    "name": "NCS S 1070-G90Y",
    "hex": "#DEC410"
  },
  {
    "name": "NCS S 1075-G90Y",
    "hex": "#DABE00"
  },
  {
    "name": "NCS S 1505-G90Y",
    "hex": "#D4D0BF"
  },
  {
    "name": "NCS S 1510-G90Y",
    "hex": "#D3CEAF"
  },
  {
    "name": "NCS S 1515-G90Y",
    "hex": "#D6CEA2"
  },
  {
    "name": "NCS S 2005-G90Y",
    "hex": "#C8C5B6"
  },
  {
    "name": "NCS S 2010-G90Y",
    "hex": "#C5C0A0"
  },
  {
    "name": "NCS S 2020-G90Y",
    "hex": "#CAC08F"
  },
  {
    "name": "NCS S 2030-G90Y",
    "hex": "#C5B774"
  },
  {
    "name": "NCS S 2040-G90Y",
    "hex": "#C8B760"
  },
  {
    "name": "NCS S 2050-G90Y",
    "hex": "#C2AF47"
  },
  {
    "name": "NCS S 2060-G90Y",
    "hex": "#C0A927"
  },
  {
    "name": "NCS S 2070-G90Y",
    "hex": "#BAA000"
  },
  {
    "name": "NCS S 3010-G90Y",
    "hex": "#AEA78C"
  },
  {
    "name": "NCS S 3020-G90Y",
    "hex": "#B2A778"
  },
  {
    "name": "NCS S 3030-G90Y",
    "hex": "#B0A160"
  },
  {
    "name": "NCS S 3040-G90Y",
    "hex": "#AF9B4D"
  },
  {
    "name": "NCS S 3050-G90Y",
    "hex": "#A59131"
  },
  {
    "name": "NCS S 3060-G90Y",
    "hex": "#9F8C13"
  },
  {
    "name": "NCS S 4010-G90Y",
    "hex": "#989279"
  },
  {
    "name": "NCS S 4020-G90Y",
    "hex": "#9B8F67"
  },
  {
    "name": "NCS S 4030-G90Y",
    "hex": "#9A8951"
  },
  {
    "name": "NCS S 4040-G90Y",
    "hex": "#948137"
  },
  {
    "name": "NCS S 4050-G90Y",
    "hex": "#8E791E"
  },
  {
    "name": "NCS S 5010-G90Y",
    "hex": "#87806A"
  },
  {
    "name": "NCS S 5020-G90Y",
    "hex": "#837853"
  },
  {
    "name": "NCS S 5030-G90Y",
    "hex": "#82723A"
  },
  {
    "name": "NCS S 5040-G90Y",
    "hex": "#786522"
  },
  {
    "name": "NCS S 6010-G90Y",
    "hex": "#6F6957"
  },
  {
    "name": "NCS S 6020-G90Y",
    "hex": "#6D613F"
  },
  {
    "name": "NCS S 6030-G90Y",
    "hex": "#69592B"
  },
  {
    "name": "NCS S 7010-G90Y",
    "hex": "#5B533F"
  },
  {
    "name": "NCS S 7020-G90Y",
    "hex": "#534729"
  },
  {
    "name": "NCS S 8010-G90Y",
    "hex": "#413A27"
  }
];
